// Generated from D:/PJ/ieum/ieum-auto/apps/realtorauto-web/lib/realtorauto-explanation-form-overlays.ts
// Source SHA-256: 3e143cf81d046b3ca50c3a371ac6b3734dda819c78596fe271e26932ceaf8d75
// 원본 RealtorAuto 편집기 동기화 파일입니다. 직접 수정하지 말고 syncRealtorAutoOriginalTemplateEditor.cjs를 실행하세요.
import { normalizeRealtorAutoAreaUnitLabel } from './realtorauto-area-display';
export const DEFAULT_EXPLANATION_FORM_OVERLAY_KEY = 'EXPLANATION_FORM_I_RESIDENTIAL_BUILDING';
export const EXPLANATION_FORM_PAGE_WIDTH_PT = 595.28;
export const EXPLANATION_FORM_PAGE_HEIGHT_PT = 841.89;
const RESIDENTIAL = 'EXPLANATION_FORM_I_RESIDENTIAL_BUILDING';
const NONRESIDENTIAL = 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING';
function pct(value, total) {
  return Number((value / total * 100).toFixed(4));
}
function textOverlay(input) {
  return {
    formKey: input.formKey,
    page: input.page,
    key: input.key,
    label: input.label,
    left: pct(input.x, EXPLANATION_FORM_PAGE_WIDTH_PT),
    top: pct(input.topY, EXPLANATION_FORM_PAGE_HEIGHT_PT),
    width: pct(input.widthPt, EXPLANATION_FORM_PAGE_WIDTH_PT),
    height: pct(input.heightPt, EXPLANATION_FORM_PAGE_HEIGHT_PT),
    multiline: input.multiline,
    align: input.align,
    fontSize: input.fontSize,
    minFontSize: input.minFontSize
  };
}
export const EXPLANATION_FORM_CHECK_HIT_WIDTH = 1.55;
export const EXPLANATION_FORM_CHECK_HIT_HEIGHT = 1.35;
function explanationFormCheckRegion(params) {
  return {
    formKey: params.formKey ?? DEFAULT_EXPLANATION_FORM_OVERLAY_KEY,
    id: params.id,
    page: params.page,
    checkKey: params.checkKey,
    label: params.label,
    centerX: params.centerX,
    centerTopY: params.centerTopY,
    left: params.centerX / EXPLANATION_FORM_PAGE_WIDTH_PT * 100,
    top: params.centerTopY / EXPLANATION_FORM_PAGE_HEIGHT_PT * 100,
    width: EXPLANATION_FORM_CHECK_HIT_WIDTH,
    height: EXPLANATION_FORM_CHECK_HIT_HEIGHT,
    optionValue: params.optionValue,
    activeOptionValues: params.activeOptionValues,
    status: params.status
  };
}
export const EXPLANATION_FORM_SEMANTIC_CHECK_OVERLAYS = [explanationFormCheckRegion({
  id: 'p1-residential-type-detached',
  page: 1,
  checkKey: 'explanation-residential-building-type',
  optionValue: 'detached',
  label: '단독주택',
  centerX: 206.17,
  centerTopY: 112.93
}), explanationFormCheckRegion({
  id: 'p1-residential-type-apartment',
  page: 1,
  checkKey: 'explanation-residential-building-type',
  optionValue: 'apartment',
  label: '공동주택',
  centerX: 288.92,
  centerTopY: 112.93
}), explanationFormCheckRegion({
  id: 'p1-residential-type-officetel',
  page: 1,
  checkKey: 'explanation-residential-building-type',
  optionValue: 'officetel',
  label: '주거용 오피스텔',
  centerX: 371.68,
  centerTopY: 112.93
}), explanationFormCheckRegion({
  id: 'p1-residential-contract-sale',
  page: 1,
  checkKey: 'explanation-contract-type',
  optionValue: 'sale',
  label: '매매ㆍ교환',
  centerX: 206.17,
  centerTopY: 127.79
}), explanationFormCheckRegion({
  id: 'p1-residential-contract-lease',
  page: 1,
  checkKey: 'explanation-contract-type',
  optionValue: 'lease',
  label: '임대',
  centerX: 288.92,
  centerTopY: 127.79
}), explanationFormCheckRegion({
  id: 'p1-source-registry-certificate',
  page: 1,
  checkKey: 'source-documents',
  label: '등기사항증명서',
  centerX: 281.4,
  centerTopY: 151.76,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  id: 'p1-source-land-register',
  page: 1,
  checkKey: 'source-documents',
  label: '토지대장',
  centerX: 362.35,
  centerTopY: 151.76,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  id: 'p1-source-building-register',
  page: 1,
  checkKey: 'source-documents',
  label: '건축물대장',
  centerX: 416.32,
  centerTopY: 151.76,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  id: 'p1-source-cadastral-map',
  page: 1,
  checkKey: 'source-documents',
  label: '지적도',
  centerX: 483.79,
  centerTopY: 151.76,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  id: 'p1-source-land-use-plan',
  page: 1,
  checkKey: 'source-documents',
  label: '토지이용계획확인서',
  centerX: 263.41,
  centerTopY: 162.19,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  id: 'p1-violation-yes',
  page: 1,
  checkKey: 'legal-restrictions',
  optionValue: 'violation',
  label: '위반건축물',
  centerX: 255.51,
  centerTopY: 480.97
}), explanationFormCheckRegion({
  id: 'p1-violation-legal',
  page: 1,
  checkKey: 'legal-restrictions',
  optionValue: 'legal',
  label: '적법',
  centerX: 291.51,
  centerTopY: 480.97
}), explanationFormCheckRegion({
  id: 'p1-land-transaction-permit-zone',
  page: 1,
  checkKey: 'legal-land-transaction-permit-zone',
  label: '토지거래허가구역',
  centerX: 339.81,
  centerTopY: 712.57
}), explanationFormCheckRegion({
  id: 'p1-land-speculation-area',
  page: 1,
  checkKey: 'legal-land-speculation-area',
  label: '토지투기지역',
  centerX: 338.79,
  centerTopY: 738.85
}), explanationFormCheckRegion({
  id: 'p1-house-speculation-area',
  page: 1,
  checkKey: 'legal-house-speculation-area',
  label: '주택투기지역',
  centerX: 408.45,
  centerTopY: 738.85
}), explanationFormCheckRegion({
  id: 'p1-overheated-speculation-district',
  page: 1,
  checkKey: 'legal-overheated-speculation-district',
  label: '투기과열지구',
  centerX: 478.17,
  centerTopY: 738.85
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-type-business',
  page: 1,
  checkKey: 'explanation-nonresidential-use-type',
  optionValue: 'business',
  label: '업무용',
  centerX: 101.82,
  centerTopY: 86.08
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-type-commercial',
  page: 1,
  checkKey: 'explanation-nonresidential-use-type',
  optionValue: 'commercial',
  label: '상업용',
  centerX: 161.79,
  centerTopY: 86.08
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-type-industrial',
  page: 1,
  checkKey: 'explanation-nonresidential-use-type',
  optionValue: 'industrial',
  label: '공업용',
  centerX: 221.76,
  centerTopY: 86.08
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-contract-sale',
  page: 1,
  checkKey: 'explanation-contract-type',
  optionValue: 'sale',
  label: '매매ㆍ교환',
  centerX: 276.21,
  centerTopY: 86.08
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-contract-lease',
  page: 1,
  checkKey: 'explanation-contract-type',
  optionValue: 'lease',
  label: '임대',
  centerX: 358.01,
  centerTopY: 86.08
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-contract-other',
  page: 1,
  checkKey: 'explanation-contract-type',
  optionValue: 'other',
  label: '그 밖의 경우',
  centerX: 406.94,
  centerTopY: 86.08
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-source-registry-certificate',
  page: 1,
  checkKey: 'source-documents',
  label: '등기사항증명서',
  centerX: 260.95,
  centerTopY: 122.52,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-source-land-register',
  page: 1,
  checkKey: 'source-documents',
  label: '토지대장',
  centerX: 342.86,
  centerTopY: 122.52,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-source-building-register',
  page: 1,
  checkKey: 'source-documents',
  label: '건축물대장',
  centerX: 400.19,
  centerTopY: 122.52,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-source-cadastral-map',
  page: 1,
  checkKey: 'source-documents',
  label: '지적도',
  centerX: 465.68,
  centerTopY: 122.52,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-source-land-use-plan',
  page: 1,
  checkKey: 'source-documents',
  label: '토지이용계획확인서',
  centerX: 262.27,
  centerTopY: 134.26,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-violation-yes',
  page: 1,
  checkKey: 'legal-restrictions',
  optionValue: 'violation',
  label: '위반건축물',
  centerX: 232.59,
  centerTopY: 480.47
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-violation-legal',
  page: 1,
  checkKey: 'legal-restrictions',
  optionValue: 'legal',
  label: '적법',
  centerX: 266.07,
  centerTopY: 480.47
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-land-transaction-permit-zone',
  page: 1,
  checkKey: 'legal-land-transaction-permit-zone',
  label: '토지거래허가구역',
  centerX: 303.63,
  centerTopY: 727.81
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-land-speculation-area',
  page: 1,
  checkKey: 'legal-land-speculation-area',
  label: '토지투기지역',
  centerX: 303.63,
  centerTopY: 747.37
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-house-speculation-area',
  page: 1,
  checkKey: 'legal-house-speculation-area',
  label: '주택투기지역',
  centerX: 373.23,
  centerTopY: 747.37
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p1-nonresidential-overheated-speculation-district',
  page: 1,
  checkKey: 'legal-overheated-speculation-district',
  label: '투기과열지구',
  centerX: 441.99,
  centerTopY: 747.37
}), explanationFormCheckRegion({
  id: 'p2-fixed-date-landlord-submit',
  page: 2,
  checkKey: 'lease-fixed-date-landlord-submit',
  label: '확정일자 임대인 자료 제출',
  centerX: 255.25,
  centerTopY: 78.62,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  id: 'p2-fixed-date-view-consent',
  page: 2,
  checkKey: 'lease-fixed-date-view-consent',
  label: '확정일자 열람 동의',
  centerX: 354.25,
  centerTopY: 78.62,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  id: 'p2-fixed-date-tenant-rights',
  page: 2,
  checkKey: 'lease-fixed-date-tenant-rights',
  label: '확정일자 임차인 권리 설명',
  centerX: 440.62,
  centerTopY: 78.62,
  status: 'OK'
}), explanationFormCheckRegion({
  id: 'p2-tax-landlord-submit',
  page: 2,
  checkKey: 'lease-tax-landlord-submit',
  label: '체납정보 임대인 자료 제출',
  centerX: 255.25,
  centerTopY: 96.12,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  id: 'p2-tax-view-consent',
  page: 2,
  checkKey: 'lease-tax-view-consent',
  label: '체납정보 열람 동의',
  centerX: 354.25,
  centerTopY: 96.12,
  status: 'NOT_APPLICABLE'
}), explanationFormCheckRegion({
  id: 'p2-tax-tenant-rights',
  page: 2,
  checkKey: 'lease-tax-tenant-rights',
  label: '체납정보 임차인 권리 설명',
  centerX: 440.62,
  centerTopY: 96.12,
  status: 'OK'
}), explanationFormCheckRegion({
  id: 'p2-household-confirmed',
  page: 2,
  checkKey: 'lease-household-confirmation',
  optionValue: 'confirmed',
  label: '전입세대 확인',
  centerX: 255.25,
  centerTopY: 110.88
}), explanationFormCheckRegion({
  id: 'p2-household-unconfirmed',
  page: 2,
  checkKey: 'lease-household-confirmation',
  optionValue: 'unconfirmed',
  label: '전입세대 미확인',
  centerX: 367.88,
  centerTopY: 110.88
}), explanationFormCheckRegion({
  id: 'p2-household-not-applicable',
  page: 2,
  checkKey: 'lease-household-confirmation',
  optionValue: 'not-applicable',
  label: '전입세대 해당 없음',
  centerX: 255.25,
  centerTopY: 122.62
}), explanationFormCheckRegion({
  id: 'p2-private-rental-public-support',
  page: 2,
  checkKey: 'lease-private-rental-type',
  optionValue: 'public-support',
  label: '공공지원민간임대주택',
  centerX: 304,
  centerTopY: 151.88
}), explanationFormCheckRegion({
  id: 'p2-deposit-guarantee-explanation',
  page: 2,
  checkKey: 'lease-deposit-guarantee-explanation',
  label: '임대보증금 보증 설명',
  centerX: 443.5,
  centerTopY: 157.62,
  status: 'OK'
}), explanationFormCheckRegion({
  id: 'p2-renewal-confirmed',
  page: 2,
  checkKey: 'lease-renewal-claim',
  optionValue: 'confirmed',
  label: '계약갱신 확인',
  centerX: 230.88,
  centerTopY: 216.38
}), explanationFormCheckRegion({
  id: 'p2-renewal-unconfirmed',
  page: 2,
  checkKey: 'lease-renewal-claim',
  optionValue: 'unconfirmed',
  label: '계약갱신 미확인',
  centerX: 352.38,
  centerTopY: 216.38
}), explanationFormCheckRegion({
  id: 'p2-renewal-not-applicable',
  page: 2,
  checkKey: 'lease-renewal-claim',
  optionValue: 'not-applicable',
  label: '계약갱신 해당 없음',
  centerX: 415.25,
  centerTopY: 216.38
}), explanationFormCheckRegion({
  id: 'p2-road-paved',
  page: 2,
  checkKey: 'location-road',
  optionValue: 'paved',
  label: '도로 포장',
  centerX: 186.75,
  centerTopY: 382.12
}), explanationFormCheckRegion({
  id: 'p2-road-unpaved',
  page: 2,
  checkKey: 'location-road',
  optionValue: 'unpaved',
  label: '도로 비포장',
  centerX: 240.75,
  centerTopY: 382.12
}), explanationFormCheckRegion({
  id: 'p2-access-easy',
  page: 2,
  checkKey: 'location-accessibility',
  optionValue: 'easy',
  label: '접근성 용이함',
  centerX: 432.5,
  centerTopY: 376.62
}), explanationFormCheckRegion({
  id: 'p2-access-inconvenient',
  page: 2,
  checkKey: 'location-accessibility',
  optionValue: 'inconvenient',
  label: '접근성 불편함',
  centerX: 495.5,
  centerTopY: 376.62
}), explanationFormCheckRegion({
  id: 'p2-bus-walk',
  page: 2,
  checkKey: 'location-bus-mode',
  optionValue: 'walk',
  label: '버스 도보',
  centerX: 401.5,
  centerTopY: 404.12
}), explanationFormCheckRegion({
  id: 'p2-bus-car',
  page: 2,
  checkKey: 'location-bus-mode',
  optionValue: 'car',
  label: '버스 차량',
  centerX: 448.12,
  centerTopY: 404.12
}), explanationFormCheckRegion({
  id: 'p2-subway-walk',
  page: 2,
  checkKey: 'location-subway-mode',
  optionValue: 'walk',
  label: '지하철 도보',
  centerX: 401.25,
  centerTopY: 433.88
}), explanationFormCheckRegion({
  id: 'p2-subway-car',
  page: 2,
  checkKey: 'location-subway-mode',
  optionValue: 'car',
  label: '지하철 차량',
  centerX: 448,
  centerTopY: 433.88
}), explanationFormCheckRegion({
  id: 'p2-parking-none',
  page: 2,
  checkKey: 'location-parking',
  optionValue: 'none',
  label: '주차장 없음',
  centerX: 186.75,
  centerTopY: 460.88
}), explanationFormCheckRegion({
  id: 'p2-parking-exclusive',
  page: 2,
  checkKey: 'location-parking',
  optionValue: 'exclusive',
  label: '전용주차시설',
  centerX: 240.75,
  centerTopY: 460.88
}), explanationFormCheckRegion({
  id: 'p2-parking-common',
  page: 2,
  checkKey: 'location-parking',
  optionValue: 'common',
  label: '공동주차시설',
  centerX: 326.25,
  centerTopY: 460.88
}), explanationFormCheckRegion({
  id: 'p2-parking-other',
  page: 2,
  checkKey: 'location-parking',
  optionValue: 'other',
  label: '그 밖의 주차시설',
  centerX: 186.75,
  centerTopY: 471.62
}), explanationFormCheckRegion({
  id: 'p2-elementary-walk',
  page: 2,
  checkKey: 'location-elementary-mode',
  optionValue: 'walk',
  label: '초등학교 도보',
  centerX: 389.88,
  centerTopY: 496.12
}), explanationFormCheckRegion({
  id: 'p2-elementary-car',
  page: 2,
  checkKey: 'location-elementary-mode',
  optionValue: 'car',
  label: '초등학교 차량',
  centerX: 440.5,
  centerTopY: 496.12
}), explanationFormCheckRegion({
  id: 'p2-middle-walk',
  page: 2,
  checkKey: 'location-middle-mode',
  optionValue: 'walk',
  label: '중학교 도보',
  centerX: 389.88,
  centerTopY: 520.12
}), explanationFormCheckRegion({
  id: 'p2-middle-car',
  page: 2,
  checkKey: 'location-middle-mode',
  optionValue: 'car',
  label: '중학교 차량',
  centerX: 440.5,
  centerTopY: 520.12
}), explanationFormCheckRegion({
  id: 'p2-high-walk',
  page: 2,
  checkKey: 'location-high-mode',
  optionValue: 'walk',
  label: '고등학교 도보',
  centerX: 389.88,
  centerTopY: 544.38
}), explanationFormCheckRegion({
  id: 'p2-high-car',
  page: 2,
  checkKey: 'location-high-mode',
  optionValue: 'car',
  label: '고등학교 차량',
  centerX: 440.5,
  centerTopY: 544.38
}), explanationFormCheckRegion({
  id: 'p2-management-security-exists',
  page: 2,
  checkKey: 'management-security-room',
  optionValue: 'exists',
  label: '경비실 있음',
  centerX: 193.2,
  centerTopY: 573.49
}), explanationFormCheckRegion({
  id: 'p2-management-security-none',
  page: 2,
  checkKey: 'management-security-room',
  optionValue: 'none',
  label: '경비실 없음',
  centerX: 249.24,
  centerTopY: 573.49
}), explanationFormCheckRegion({
  id: 'p2-management-subject-entrusted',
  page: 2,
  checkKey: 'management-subject',
  optionValue: 'entrusted',
  label: '위탁관리',
  centerX: 342.78,
  centerTopY: 573.13
}), explanationFormCheckRegion({
  id: 'p2-management-subject-self',
  page: 2,
  checkKey: 'management-subject',
  optionValue: 'self',
  label: '자체관리',
  centerX: 407.58,
  centerTopY: 573.13
}), explanationFormCheckRegion({
  id: 'p2-management-subject-other',
  page: 2,
  checkKey: 'management-subject',
  optionValue: 'other',
  label: '그 밖의 유형',
  centerX: 472.38,
  centerTopY: 573.13
}), explanationFormCheckRegion({
  id: 'p2-management-fee-electricity',
  page: 2,
  checkKey: 'management-fee-electricity',
  label: '관리비 전기료',
  centerX: 262.88,
  centerTopY: 610.88,
  status: 'OK'
}), explanationFormCheckRegion({
  id: 'p2-management-fee-water',
  page: 2,
  checkKey: 'management-fee-water',
  label: '관리비 수도료',
  centerX: 307.62,
  centerTopY: 610.88,
  status: 'OK'
}), explanationFormCheckRegion({
  id: 'p2-management-fee-gas',
  page: 2,
  checkKey: 'management-fee-gas',
  label: '관리비 가스사용료',
  centerX: 352.62,
  centerTopY: 610.88,
  status: 'OK'
}), explanationFormCheckRegion({
  id: 'p2-management-fee-heating',
  page: 2,
  checkKey: 'management-fee-heating',
  label: '관리비 난방비',
  centerX: 412.38,
  centerTopY: 610.88,
  status: 'OK'
}), explanationFormCheckRegion({
  id: 'p2-management-fee-internet',
  page: 2,
  checkKey: 'management-fee-internet',
  label: '관리비 인터넷 사용료',
  centerX: 457.12,
  centerTopY: 610.88,
  status: 'OK'
}), explanationFormCheckRegion({
  id: 'p2-management-charge-direct',
  page: 2,
  checkKey: 'management-charge-method',
  optionValue: 'direct',
  label: '임대인이 직접 부과',
  centerX: 262.88,
  centerTopY: 638.62
}), explanationFormCheckRegion({
  id: 'p2-management-charge-rules',
  page: 2,
  checkKey: 'management-charge-method',
  optionValue: 'rules',
  label: '관리규약에 따라 부과',
  centerX: 352.62,
  centerTopY: 638.62
}), explanationFormCheckRegion({
  id: 'p2-management-charge-other',
  page: 2,
  checkKey: 'management-charge-method',
  optionValue: 'other',
  label: '그 밖의 부과 방식',
  centerX: 262.88,
  centerTopY: 649.38
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-road-paved',
  page: 2,
  checkKey: 'location-road',
  optionValue: 'paved',
  label: '도로 포장',
  centerX: 252.66,
  centerTopY: 66.85
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-road-unpaved',
  page: 2,
  checkKey: 'location-road',
  optionValue: 'unpaved',
  label: '도로 비포장',
  centerX: 295.26,
  centerTopY: 66.85
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-access-easy',
  page: 2,
  checkKey: 'location-accessibility',
  optionValue: 'easy',
  label: '접근성 용이함',
  centerX: 413.22,
  centerTopY: 66.85
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-access-inconvenient',
  page: 2,
  checkKey: 'location-accessibility',
  optionValue: 'inconvenient',
  label: '접근성 불편함',
  centerX: 470.58,
  centerTopY: 66.85
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-bus-walk',
  page: 2,
  checkKey: 'location-bus-mode',
  optionValue: 'walk',
  label: '버스 도보',
  centerX: 367.26,
  centerTopY: 91.67
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-bus-car',
  page: 2,
  checkKey: 'location-bus-mode',
  optionValue: 'car',
  label: '버스 차량',
  centerX: 411.9,
  centerTopY: 91.67
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-subway-walk',
  page: 2,
  checkKey: 'location-subway-mode',
  optionValue: 'walk',
  label: '지하철 도보',
  centerX: 367.26,
  centerTopY: 115.79
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-subway-car',
  page: 2,
  checkKey: 'location-subway-mode',
  optionValue: 'car',
  label: '지하철 차량',
  centerX: 411.9,
  centerTopY: 115.79
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-parking-none',
  page: 2,
  checkKey: 'location-parking',
  optionValue: 'none',
  label: '주차장 없음',
  centerX: 158.94,
  centerTopY: 139.81
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-parking-exclusive',
  page: 2,
  checkKey: 'location-parking',
  optionValue: 'exclusive',
  label: '전용주차시설',
  centerX: 216.72,
  centerTopY: 139.81
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-parking-common',
  page: 2,
  checkKey: 'location-parking',
  optionValue: 'common',
  label: '공동주차시설',
  centerX: 303.9,
  centerTopY: 139.81
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-parking-other',
  page: 2,
  checkKey: 'location-parking',
  optionValue: 'other',
  label: '그 밖의 주차시설',
  centerX: 391.08,
  centerTopY: 139.81
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-management-security-exists',
  page: 2,
  checkKey: 'management-security-room',
  optionValue: 'exists',
  label: '경비실 있음',
  centerX: 159,
  centerTopY: 169.93
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-management-security-none',
  page: 2,
  checkKey: 'management-security-room',
  optionValue: 'none',
  label: '경비실 없음',
  centerX: 217.44,
  centerTopY: 169.93
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-management-subject-entrusted',
  page: 2,
  checkKey: 'management-subject',
  optionValue: 'entrusted',
  label: '관리주체 위탁관리',
  centerX: 352.26,
  centerTopY: 169.57
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-management-subject-self',
  page: 2,
  checkKey: 'management-subject',
  optionValue: 'self',
  label: '관리주체 자체관리',
  centerX: 413.34,
  centerTopY: 169.57
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-management-subject-other',
  page: 2,
  checkKey: 'management-subject',
  optionValue: 'other',
  label: '관리주체 그 밖의 유형',
  centerX: 469.27,
  centerTopY: 169.74
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-water-damage-none',
  page: 2,
  checkKey: 'facility-water-damage',
  optionValue: 'none',
  label: '수도 파손 없음',
  centerX: 222.36,
  centerTopY: 453.74
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-water-damage-exists',
  page: 2,
  checkKey: 'facility-water-damage',
  optionValue: 'exists',
  label: '수도 파손 있음',
  centerX: 292.2,
  centerTopY: 453.74
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-water-capacity-normal',
  page: 2,
  checkKey: 'facility-water-capacity',
  optionValue: 'normal',
  label: '수도 용수량 정상',
  centerX: 222.36,
  centerTopY: 477.86
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-water-capacity-insufficient',
  page: 2,
  checkKey: 'facility-water-capacity',
  optionValue: 'insufficient',
  label: '수도 용수량 부족함',
  centerX: 292.2,
  centerTopY: 477.86
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-electric-normal',
  page: 2,
  checkKey: 'facility-electric',
  optionValue: 'normal',
  label: '전기 공급상태 정상',
  centerX: 222.36,
  centerTopY: 501.98
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-electric-repair',
  page: 2,
  checkKey: 'facility-electric',
  optionValue: 'repair',
  label: '전기 교체 필요',
  centerX: 292.2,
  centerTopY: 501.98
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-gas-city',
  page: 2,
  checkKey: 'facility-gas',
  optionValue: 'city-gas',
  label: '취사용 가스 도시가스',
  centerX: 222.36,
  centerTopY: 525.98
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-gas-other',
  page: 2,
  checkKey: 'facility-gas',
  optionValue: 'other',
  label: '취사용 가스 그 밖의 방식',
  centerX: 292.2,
  centerTopY: 525.98
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-fire-hydrant-none',
  page: 2,
  checkKey: 'facility-fire-hydrant',
  optionValue: 'none',
  label: '소화전 없음',
  centerX: 222.36,
  centerTopY: 550.1
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-fire-hydrant-exists',
  page: 2,
  checkKey: 'facility-fire-hydrant',
  optionValue: 'exists',
  label: '소화전 있음',
  centerX: 292.2,
  centerTopY: 550.1
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-emergency-bell-none',
  page: 2,
  checkKey: 'facility-emergency-bell',
  optionValue: 'none',
  label: '비상벨 없음',
  centerX: 222.36,
  centerTopY: 574.22
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-emergency-bell-exists',
  page: 2,
  checkKey: 'facility-emergency-bell',
  optionValue: 'exists',
  label: '비상벨 있음',
  centerX: 292.2,
  centerTopY: 574.22
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-heating-action-normal',
  page: 2,
  checkKey: 'facility-heating-action',
  optionValue: 'normal',
  label: '난방 시설작동 정상',
  centerX: 380.94,
  centerTopY: 594.38
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-heating-action-repair',
  page: 2,
  checkKey: 'facility-heating-action',
  optionValue: 'repair',
  label: '난방 시설작동 수선 필요',
  centerX: 413.1,
  centerTopY: 594.38
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-heating-central',
  page: 2,
  checkKey: 'facility-heating',
  optionValue: 'central-heating',
  label: '난방 중앙공급',
  centerX: 222.36,
  centerTopY: 598.34
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-heating-individual',
  page: 2,
  checkKey: 'facility-heating',
  optionValue: 'individual-heating',
  label: '난방 개별공급',
  centerX: 281.4,
  centerTopY: 598.34
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-heating-action-unknown',
  page: 2,
  checkKey: 'facility-heating-action',
  optionValue: 'unknown',
  label: '난방 시설작동 확인불가',
  centerX: 489.84,
  centerTopY: 602.06
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-fuel-city',
  page: 2,
  checkKey: 'facility-fuel',
  optionValue: 'city-gas',
  label: '연료 도시가스',
  centerX: 222.24,
  centerTopY: 622.34
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-fuel-oil',
  page: 2,
  checkKey: 'facility-fuel',
  optionValue: 'oil',
  label: '연료 기름',
  centerX: 281.1,
  centerTopY: 622.34
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-fuel-propane',
  page: 2,
  checkKey: 'facility-fuel',
  optionValue: 'propane',
  label: '연료 프로판가스',
  centerX: 324.54,
  centerTopY: 622.34
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-fuel-coal',
  page: 2,
  checkKey: 'facility-fuel',
  optionValue: 'coal',
  label: '연료 연탄',
  centerX: 389.82,
  centerTopY: 622.34
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-fuel-other',
  page: 2,
  checkKey: 'facility-fuel',
  optionValue: 'other',
  label: '연료 그 밖의 종류',
  centerX: 429.66,
  centerTopY: 622.34
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-elevator-exists',
  page: 2,
  checkKey: 'facility-elevator',
  optionValue: 'exists-good',
  activeOptionValues: ['exists-good', 'exists-repair'],
  label: '승강기 있음',
  centerX: 174.78,
  centerTopY: 646.46
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-elevator-good',
  page: 2,
  checkKey: 'facility-elevator',
  optionValue: 'exists-good',
  label: '승강기 있음 양호',
  centerX: 224.16,
  centerTopY: 646.46
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-elevator-repair',
  page: 2,
  checkKey: 'facility-elevator',
  optionValue: 'exists-repair',
  label: '승강기 있음 불량',
  centerX: 270.48,
  centerTopY: 646.46
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-elevator-none',
  page: 2,
  checkKey: 'facility-elevator',
  optionValue: 'none',
  label: '승강기 없음',
  centerX: 324.84,
  centerTopY: 646.46
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-drain-normal',
  page: 2,
  checkKey: 'facility-drain',
  optionValue: 'normal',
  label: '배수 정상',
  centerX: 174.78,
  centerTopY: 670.58
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-drain-repair',
  page: 2,
  checkKey: 'facility-drain',
  optionValue: 'repair',
  label: '배수 수선 필요',
  centerX: 223.92,
  centerTopY: 670.58
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-wall-crack-none',
  page: 2,
  checkKey: 'wall-crack',
  optionValue: 'none',
  label: '벽면 균열 없음',
  centerX: 199.68,
  centerTopY: 717.86
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-wall-crack-exists',
  page: 2,
  checkKey: 'wall-crack',
  optionValue: 'exists',
  label: '벽면 균열 있음',
  centerX: 250.14,
  centerTopY: 717.86
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-wall-leak-none',
  page: 2,
  checkKey: 'wall-leak',
  optionValue: 'none',
  label: '벽면 누수 없음',
  centerX: 199.68,
  centerTopY: 732.5
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-wall-leak-exists',
  page: 2,
  checkKey: 'wall-leak',
  optionValue: 'exists',
  label: '벽면 누수 있음',
  centerX: 250.14,
  centerTopY: 732.5
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-floor-clean',
  page: 2,
  checkKey: 'floor-state',
  optionValue: 'clean',
  label: '바닥면 깨끗함',
  centerX: 170.46,
  centerTopY: 753.71
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-floor-normal',
  page: 2,
  checkKey: 'floor-state',
  optionValue: 'normal',
  label: '바닥면 보통임',
  centerX: 226.26,
  centerTopY: 753.71
}), explanationFormCheckRegion({
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  id: 'p2-nonresidential-floor-repair',
  page: 2,
  checkKey: 'floor-state',
  optionValue: 'repair',
  label: '바닥면 수리 필요',
  centerX: 278.34,
  centerTopY: 753.71
}), explanationFormCheckRegion({
  id: 'p2-disliked-none',
  page: 2,
  checkKey: 'location-disliked-facility',
  optionValue: 'none',
  label: '비선호시설 없음',
  centerX: 197.75,
  centerTopY: 676.38
}), explanationFormCheckRegion({
  id: 'p2-disliked-exists',
  page: 2,
  checkKey: 'location-disliked-facility',
  optionValue: 'exists',
  label: '비선호시설 있음',
  centerX: 268.62,
  centerTopY: 676.38
}), explanationFormCheckRegion({
  id: 'p3-water-damage-none',
  page: 3,
  checkKey: 'facility-water-damage',
  optionValue: 'none',
  label: '수도 파손 없음',
  centerX: 239.62,
  centerTopY: 236.62
}), explanationFormCheckRegion({
  id: 'p3-water-damage-exists',
  page: 3,
  checkKey: 'facility-water-damage',
  optionValue: 'exists',
  label: '수도 파손 있음',
  centerX: 311.62,
  centerTopY: 236.62
}), explanationFormCheckRegion({
  id: 'p3-water-capacity-normal',
  page: 3,
  checkKey: 'facility-water-capacity',
  optionValue: 'normal',
  label: '수도 용수량 정상',
  centerX: 239.62,
  centerTopY: 260.62
}), explanationFormCheckRegion({
  id: 'p3-water-capacity-insufficient',
  page: 3,
  checkKey: 'facility-water-capacity',
  optionValue: 'insufficient',
  label: '수도 용수량 부족함',
  centerX: 311.62,
  centerTopY: 260.62
}), explanationFormCheckRegion({
  id: 'p3-electric-normal',
  page: 3,
  checkKey: 'facility-electric',
  optionValue: 'normal',
  label: '전기 공급상태 정상',
  centerX: 239.62,
  centerTopY: 285.38
}), explanationFormCheckRegion({
  id: 'p3-electric-repair',
  page: 3,
  checkKey: 'facility-electric',
  optionValue: 'repair',
  label: '전기 교체 필요',
  centerX: 311.62,
  centerTopY: 285.38
}), explanationFormCheckRegion({
  id: 'p3-gas-city',
  page: 3,
  checkKey: 'facility-gas',
  optionValue: 'city-gas',
  label: '도시가스',
  centerX: 239.62,
  centerTopY: 310.88
}), explanationFormCheckRegion({
  id: 'p3-gas-other',
  page: 3,
  checkKey: 'facility-gas',
  optionValue: 'other',
  label: '그 밖의 방식',
  centerX: 311.62,
  centerTopY: 310.88
}), explanationFormCheckRegion({
  id: 'p3-fire-none',
  page: 3,
  checkKey: 'facility-fire',
  optionValue: 'none',
  label: '소방 없음',
  centerX: 239.62,
  centerTopY: 344.62
}), explanationFormCheckRegion({
  id: 'p3-fire-exists',
  page: 3,
  checkKey: 'facility-fire',
  optionValue: 'exists',
  label: '소방 있음',
  centerX: 239,
  centerTopY: 354.88
}), explanationFormCheckRegion({
  id: 'p3-heating-central',
  page: 3,
  checkKey: 'facility-heating',
  optionValue: 'central-heating',
  label: '중앙공급',
  centerX: 239.62,
  centerTopY: 385.38
}), explanationFormCheckRegion({
  id: 'p3-heating-individual',
  page: 3,
  checkKey: 'facility-heating',
  optionValue: 'individual-heating',
  label: '개별공급',
  centerX: 239.62,
  centerTopY: 395.88
}), explanationFormCheckRegion({
  id: 'p3-heating-district',
  page: 3,
  checkKey: 'facility-heating',
  optionValue: 'district-heating',
  label: '지역난방',
  centerX: 239.25,
  centerTopY: 406.12
}), explanationFormCheckRegion({
  id: 'p3-heating-action-normal',
  page: 3,
  checkKey: 'facility-heating-action',
  optionValue: 'normal',
  label: '시설작동 정상',
  centerX: 351.5,
  centerTopY: 390.62
}), explanationFormCheckRegion({
  id: 'p3-heating-action-repair',
  page: 3,
  checkKey: 'facility-heating-action',
  optionValue: 'repair',
  label: '시설작동 수선 필요',
  centerX: 391.5,
  centerTopY: 390.62
}), explanationFormCheckRegion({
  id: 'p3-heating-action-unknown',
  page: 3,
  checkKey: 'facility-heating-action',
  optionValue: 'unknown',
  label: '시설작동 확인불가',
  centerX: 494.38,
  centerTopY: 401.12
}), explanationFormCheckRegion({
  id: 'p3-fuel-city',
  page: 3,
  checkKey: 'facility-fuel',
  optionValue: 'city-gas',
  label: '도시가스',
  centerX: 239.62,
  centerTopY: 425.62
}), explanationFormCheckRegion({
  id: 'p3-fuel-oil',
  page: 3,
  checkKey: 'facility-fuel',
  optionValue: 'oil',
  label: '기름',
  centerX: 307.5,
  centerTopY: 425.62
}), explanationFormCheckRegion({
  id: 'p3-fuel-propane',
  page: 3,
  checkKey: 'facility-fuel',
  optionValue: 'propane',
  label: '프로판가스',
  centerX: 359.62,
  centerTopY: 425.62
}), explanationFormCheckRegion({
  id: 'p3-fuel-coal',
  page: 3,
  checkKey: 'facility-fuel',
  optionValue: 'coal',
  label: '연탄',
  centerX: 435.62,
  centerTopY: 425.62
}), explanationFormCheckRegion({
  id: 'p3-fuel-other',
  page: 3,
  checkKey: 'facility-fuel',
  optionValue: 'other',
  label: '그 밖의 종류',
  centerX: 239.62,
  centerTopY: 435.88
}), explanationFormCheckRegion({
  id: 'p3-elevator-exists',
  page: 3,
  checkKey: 'facility-elevator',
  optionValue: 'exists-good',
  activeOptionValues: ['exists-good', 'exists-repair'],
  label: '승강기 있음',
  centerX: 189.5,
  centerTopY: 457.62
}), explanationFormCheckRegion({
  id: 'p3-elevator-good',
  page: 3,
  checkKey: 'facility-elevator',
  optionValue: 'exists-good',
  label: '승강기 있음 양호',
  centerX: 241.38,
  centerTopY: 457.62
}), explanationFormCheckRegion({
  id: 'p3-elevator-repair',
  page: 3,
  checkKey: 'facility-elevator',
  optionValue: 'exists-repair',
  label: '승강기 있음 불량',
  centerX: 289.38,
  centerTopY: 457.62
}), explanationFormCheckRegion({
  id: 'p3-elevator-none',
  page: 3,
  checkKey: 'facility-elevator',
  optionValue: 'none',
  label: '승강기 없음',
  centerX: 345.5,
  centerTopY: 457.62
}), explanationFormCheckRegion({
  id: 'p3-drain-normal',
  page: 3,
  checkKey: 'facility-drain',
  optionValue: 'normal',
  label: '배수 정상',
  centerX: 189.5,
  centerTopY: 481.88
}), explanationFormCheckRegion({
  id: 'p3-drain-repair',
  page: 3,
  checkKey: 'facility-drain',
  optionValue: 'repair',
  label: '배수 수선 필요',
  centerX: 237.5,
  centerTopY: 481.88
}), explanationFormCheckRegion({
  id: 'p3-wall-mold-none',
  page: 3,
  checkKey: 'wall-crack',
  optionValue: 'none',
  label: '벽면 균열 없음',
  centerX: 226.0,
  centerTopY: 539.88
}), explanationFormCheckRegion({
  id: 'p3-wall-mold-exists',
  page: 3,
  checkKey: 'wall-crack',
  optionValue: 'exists',
  label: '벽면 균열 있음',
  centerX: 286.0,
  centerTopY: 539.88
}), explanationFormCheckRegion({
  id: 'p3-wall-leak-none',
  page: 3,
  checkKey: 'wall-leak',
  optionValue: 'none',
  label: '벽면 누수 없음',
  centerX: 226.0,
  centerTopY: 564.62
}), explanationFormCheckRegion({
  id: 'p3-wall-leak-exists',
  page: 3,
  checkKey: 'wall-leak',
  optionValue: 'exists',
  label: '벽면 누수 있음',
  centerX: 286.0,
  centerTopY: 564.62
}), explanationFormCheckRegion({
  id: 'p3-floor-clean',
  page: 3,
  checkKey: 'floor-state',
  optionValue: 'clean',
  label: '바닥면 깨끗함',
  centerX: 189.5,
  centerTopY: 590.12
}), explanationFormCheckRegion({
  id: 'p3-floor-normal',
  page: 3,
  checkKey: 'floor-state',
  optionValue: 'normal',
  label: '바닥면 보통임',
  centerX: 257.38,
  centerTopY: 590.12
}), explanationFormCheckRegion({
  id: 'p3-floor-repair',
  page: 3,
  checkKey: 'floor-state',
  optionValue: 'repair',
  label: '바닥면 수리 필요',
  centerX: 321.5,
  centerTopY: 590.12
}), explanationFormCheckRegion({
  id: 'p3-paper-clean',
  page: 3,
  checkKey: 'papering-state',
  optionValue: 'clean',
  label: '도배 깨끗함',
  centerX: 189.5,
  centerTopY: 615.88
}), explanationFormCheckRegion({
  id: 'p3-paper-normal',
  page: 3,
  checkKey: 'papering-state',
  optionValue: 'normal',
  label: '도배 보통임',
  centerX: 257.38,
  centerTopY: 615.88
}), explanationFormCheckRegion({
  id: 'p3-paper-repair',
  page: 3,
  checkKey: 'papering-state',
  optionValue: 'repair',
  label: '도배 필요',
  centerX: 321.5,
  centerTopY: 615.88
}), explanationFormCheckRegion({
  id: 'p3-light-abundant',
  page: 3,
  checkKey: 'environment-light',
  optionValue: 'abundant',
  label: '일조량 풍부함',
  centerX: 189.5,
  centerTopY: 646.12
}), explanationFormCheckRegion({
  id: 'p3-light-normal',
  page: 3,
  checkKey: 'environment-light',
  optionValue: 'normal',
  label: '일조량 보통임',
  centerX: 257.38,
  centerTopY: 646.12
}), explanationFormCheckRegion({
  id: 'p3-light-insufficient',
  page: 3,
  checkKey: 'environment-light',
  optionValue: 'insufficient',
  label: '일조량 불충분',
  centerX: 321.5,
  centerTopY: 646.12
}), explanationFormCheckRegion({
  id: 'p3-noise-very-low',
  page: 3,
  checkKey: 'environment-noise',
  optionValue: 'very-low',
  label: '소음 아주 작음',
  centerX: 188.88,
  centerTopY: 671.88
}), explanationFormCheckRegion({
  id: 'p3-noise-normal',
  page: 3,
  checkKey: 'environment-noise',
  optionValue: 'normal',
  label: '소음 보통임',
  centerX: 250.25,
  centerTopY: 671.88
}), explanationFormCheckRegion({
  id: 'p3-noise-severe',
  page: 3,
  checkKey: 'environment-noise',
  optionValue: 'severe',
  label: '소음 심한 편임',
  centerX: 300.25,
  centerTopY: 671.88
}), explanationFormCheckRegion({
  id: 'p3-vibration-very-low',
  page: 3,
  checkKey: 'environment-vibration',
  optionValue: 'very-low',
  label: '진동 아주 작음',
  centerX: 395.88,
  centerTopY: 671.88
}), explanationFormCheckRegion({
  id: 'p3-vibration-normal',
  page: 3,
  checkKey: 'environment-vibration',
  optionValue: 'normal',
  label: '진동 보통임',
  centerX: 448.88,
  centerTopY: 671.88
}), explanationFormCheckRegion({
  id: 'p3-vibration-severe',
  page: 3,
  checkKey: 'environment-vibration',
  optionValue: 'severe',
  label: '진동 심한 편임',
  centerX: 494.88,
  centerTopY: 671.88
}), explanationFormCheckRegion({
  id: 'p3-guide-licensed-broker',
  page: 3,
  checkKey: 'site-guide',
  optionValue: 'licensed-broker',
  label: '개업공인중개사',
  centerX: 185.0,
  centerTopY: 698.62
}), explanationFormCheckRegion({
  id: 'p3-guide-affiliated-broker',
  page: 3,
  checkKey: 'site-guide',
  optionValue: 'affiliated-broker',
  label: '소속공인중개사',
  centerX: 266.12,
  centerTopY: 698.62
}), explanationFormCheckRegion({
  id: 'p3-guide-assistant',
  page: 3,
  checkKey: 'site-guide',
  optionValue: 'assistant',
  label: '중개보조원',
  centerX: 347.25,
  centerTopY: 698.62
}), explanationFormCheckRegion({
  id: 'p3-guide-assistant-notice-yes',
  page: 3,
  checkKey: 'site-guide-notice',
  optionValue: 'yes',
  label: '중개보조원 신분고지 예',
  centerX: 467.0,
  centerTopY: 698.62
}), explanationFormCheckRegion({
  id: 'p3-guide-assistant-notice-no',
  page: 3,
  checkKey: 'site-guide-notice',
  optionValue: 'no',
  label: '중개보조원 신분고지 아니오',
  centerX: 499.38,
  centerTopY: 698.62
}), explanationFormCheckRegion({
  id: 'p3-guide-none',
  page: 3,
  checkKey: 'site-guide',
  optionValue: 'none',
  label: '해당 없음',
  centerX: 185.75,
  centerTopY: 710.12
})];
export const EXPLANATION_FORM_DETECTED_CHECK_CENTER_GROUPS = [{
  formKey: 'EXPLANATION_FORM_I_RESIDENTIAL_BUILDING',
  prefix: 'residential',
  label: '주거용',
  pages: {
    1: [[206.17, 112.93], [288.92, 112.93], [371.68, 112.93], [206.17, 127.79], [288.92, 127.79], [218.43, 151.76], [281.4, 151.76], [362.35, 151.76], [416.32, 151.76], [483.79, 151.76], [218.43, 162.19], [263.41, 162.19], [362.35, 162.19], [456.8, 162.19], [218.43, 172.5], [299.39, 172.5], [389.34, 172.5], [255.51, 480.97], [291.51, 480.97], [339.81, 712.57], [338.79, 738.85], [408.45, 738.85], [478.17, 738.85]],
    2: [[255.33, 78.49], [354.27, 78.49], [440.61, 78.49], [255.33, 96.01], [354.27, 96.01], [440.61, 96.01], [255.33, 110.65], [367.83, 110.65], [255.33, 122.41], [187.11, 151.69], [304.05, 151.69], [443.49, 157.57], [187.11, 163.45], [190.53, 195.73], [230.91, 216.37], [352.35, 216.37], [415.29, 216.37], [432.54, 376.57], [495.48, 376.57], [186.78, 381.97], [240.72, 381.97], [401.52, 403.93], [448.08, 403.93], [401.28, 433.69], [447.96, 433.69], [186.78, 460.81], [240.72, 460.81], [326.16, 460.81], [186.78, 471.61], [389.88, 495.97], [440.46, 495.97], [389.88, 520.09], [440.46, 520.09], [389.88, 544.21], [440.46, 544.21], [342.78, 573.13], [407.58, 573.13], [472.38, 573.13], [193.2, 573.49], [249.24, 573.49], [262.89, 610.81], [307.71, 610.81], [352.59, 610.81], [412.35, 610.81], [457.23, 610.81], [262.95, 621.61], [319.05, 621.61], [262.89, 638.41], [352.59, 638.41], [262.95, 649.21], [197.76, 676.21], [268.56, 676.21]],
    3: [[239.58, 236.51], [311.58, 236.51], [239.58, 260.63], [311.58, 260.63], [239.58, 285.35], [311.58, 285.35], [239.58, 310.91], [311.58, 310.91], [239.58, 344.51], [238.98, 354.95], [239.58, 385.43], [351.42, 390.59], [391.44, 390.59], [239.58, 395.87], [494.43, 401.03], [239.61, 406.19], [239.58, 425.51], [307.56, 425.51], [359.58, 425.51], [435.6, 425.51], [239.58, 435.95], [189.36, 457.67], [241.32, 457.67], [289.32, 457.67], [345.36, 457.67], [189.36, 481.79], [237.36, 481.79], [225.9, 539.75], [285.9, 539.75], [225.9, 564.71], [285.9, 564.71], [189.36, 590.03], [257.34, 590.03], [321.36, 590.03], [189.36, 615.83], [257.34, 615.83], [321.36, 615.83], [189.36, 646.19], [257.34, 646.19], [321.36, 646.19], [188.82, 671.75], [250.26, 671.75], [300.18, 671.75], [395.76, 671.75], [448.92, 671.75], [494.88, 671.75], [185.04, 698.41], [266.16, 698.41], [347.28, 698.41], [467.07, 698.41], [499.29, 698.41], [185.7, 710.05]],
    5: [[88.53, 119.89], [204.45, 119.89], [408.99, 767.89]]
  }
}, {
  formKey: 'EXPLANATION_FORM_II_NONRESIDENTIAL_BUILDING',
  prefix: 'nonresidential',
  label: '상가',
  pages: {
    1: [[101.82, 86.08], [161.79, 86.08], [221.76, 86.08], [276.21, 86.08], [358.01, 86.08], [406.94, 86.08], [195.4, 122.52], [260.95, 122.52], [342.86, 122.52], [400.19, 122.52], [465.68, 122.52], [195.52, 134.26], [262.27, 134.26], [366.61, 134.26], [232.59, 480.47], [266.07, 480.47], [151.05, 573.13], [267.99, 573.13], [151.05, 584.89], [151.05, 614.05], [151.05, 641.77], [285.93, 641.77], [371.25, 641.77], [303.63, 727.81], [303.63, 747.37], [373.23, 747.37], [441.99, 747.37]],
    2: [[252.66, 66.85], [295.26, 66.85], [413.22, 66.85], [470.58, 66.85], [367.26, 91.67], [411.9, 91.67], [367.26, 115.79], [411.9, 115.79], [158.94, 139.81], [216.72, 139.81], [303.9, 139.81], [391.08, 139.81], [352.26, 169.57], [413.34, 169.57], [469.27, 169.74], [159, 169.93], [217.44, 169.93], [222.36, 453.74], [292.2, 453.74], [222.36, 477.86], [292.2, 477.86], [222.36, 501.98], [292.2, 501.98], [222.36, 525.98], [292.2, 525.98], [222.36, 550.1], [292.2, 550.1], [222.36, 574.22], [292.2, 574.22], [380.94, 594.38], [413.1, 594.38], [222.36, 598.34], [281.4, 598.34], [489.84, 602.06], [222.24, 622.34], [281.1, 622.34], [324.54, 622.34], [389.82, 622.34], [429.66, 622.34], [174.78, 646.46], [224.16, 646.46], [270.48, 646.46], [324.84, 646.46], [174.78, 670.58], [223.92, 670.58], [199.68, 717.86], [250.14, 717.86], [199.68, 732.5], [250.14, 732.5], [170.46, 753.71], [226.26, 753.71], [278.34, 753.71]],
    4: [[74.79, 79.79], [184.59, 79.79], [351.03, 258.95]]
  }
}];
export function explanationFormDetectedCheckRegions() {
  return EXPLANATION_FORM_DETECTED_CHECK_CENTER_GROUPS.flatMap(group => Object.entries(group.pages).flatMap(([pageText, centers]) => {
    const page = Number(pageText);
    return centers.map(([centerX, centerTopY], index) => explanationFormCheckRegion({
      formKey: group.formKey,
      id: `${group.prefix}-detected-p${page}-${String(index + 1).padStart(3, '0')}`,
      page,
      checkKey: `${group.prefix}-detected-p${page}-${String(index + 1).padStart(3, '0')}`,
      label: `${group.label} ${page}쪽 미연결 원본 체크박스 ${index + 1}`,
      centerX,
      centerTopY,
      status: 'NOT_APPLICABLE'
    }));
  }));
}
export function mergeExplanationFormCheckOverlays(primary, detected) {
  const merged = [...primary];
  detected.forEach(candidate => {
    const duplicated = merged.some(item => item.formKey === candidate.formKey && item.page === candidate.page && Math.abs(item.left - candidate.left) < 0.35 && Math.abs(item.top - candidate.top) < 0.35);
    if (!duplicated) merged.push(candidate);
  });
  return merged;
}
export const EXPLANATION_FORM_CHECK_OVERLAYS = mergeExplanationFormCheckOverlays(EXPLANATION_FORM_SEMANTIC_CHECK_OVERLAYS, explanationFormDetectedCheckRegions());
export function findExplanationFormCheckOverlayById(id) {
  return EXPLANATION_FORM_CHECK_OVERLAYS.find(field => field.id === id);
}
export function explanationCheckOverlayBelongsToForm(field, formKey) {
  return (field.formKey ?? DEFAULT_EXPLANATION_FORM_OVERLAY_KEY) === formKey;
}
export function explanationCheckOverlayMatchesState(field, status, selectedOption = '') {
  if (field.activeOptionValues?.length) return status === 'OK' && field.activeOptionValues.includes(selectedOption);
  if (field.optionValue) return status === 'OK' && selectedOption === field.optionValue;
  const activeStatus = field.status ?? 'OK';
  if (activeStatus === 'NOT_APPLICABLE') return false;
  return status === activeStatus;
}
export function explanationTextOverlayBelongsToForm(field, formKey) {
  return field.formKey === formKey;
}
const KOREAN_SIDO_PATTERN = /(?:\uC11C\uC6B8\uD2B9\uBCC4\uC2DC|\uBD80\uC0B0\uAD11\uC5ED\uC2DC|\uB300\uAD6C\uAD11\uC5ED\uC2DC|\uC778\uCC9C\uAD11\uC5ED\uC2DC|\uAD11\uC8FC\uAD11\uC5ED\uC2DC|\uB300\uC804\uAD11\uC5ED\uC2DC|\uC6B8\uC0B0\uAD11\uC5ED\uC2DC|\uC138\uC885\uD2B9\uBCC4\uC790\uCE58\uC2DC|\uACBD\uAE30\uB3C4|\uAC15\uC6D0\uD2B9\uBCC4\uC790\uCE58\uB3C4|\uAC15\uC6D0\uB3C4|\uCDA9\uCCAD\uBD81\uB3C4|\uCDA9\uCCAD\uB0A8\uB3C4|\uC804\uB77C\uBD81\uB3C4|\uC804\uBD81\uD2B9\uBCC4\uC790\uCE58\uB3C4|\uC804\uB77C\uB0A8\uB3C4|\uACBD\uC0C1\uBD81\uB3C4|\uACBD\uC0C1\uB0A8\uB3C4|\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4)/u;
export const EXPLANATION_FORM_LEFT_TEXT_INSET_PX = 7;
export const EXPLANATION_FORM_PREVIEW_BASE_WIDTH_PX = 820;
export const EXPLANATION_FORM_GENERAL_MIN_FONT_SIZE_PT = 6;
export const EXPLANATION_FORM_ADDRESS_MIN_FONT_SIZE_PT = 10;
export const EXPLANATION_FORM_ADDRESS_SINGLE_LINE_MIN_FONT_SIZE_PT = 7;
function documentNumericDigits(value) {
  return String(value ?? '').replace(/\D/gu, '');
}
export function formatDocumentPhoneNumberText(value) {
  const text = String(value ?? '');
  const digits = documentNumericDigits(text);
  if (digits.length === 8) return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  if (digits.length === 10) return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11) return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
  return text;
}
export function formatDocumentBirthOrResidentNumberText(value) {
  const text = String(value ?? '');
  const digits = documentNumericDigits(text);
  if (digits.length === 6) return `${digits.slice(0, 2)}년 ${digits.slice(2, 4)}월 ${digits.slice(4)}일`;
  if (digits.length === 8) return `${digits.slice(0, 4)}년 ${digits.slice(4, 6)}월 ${digits.slice(6)}일`;
  if (digits.length === 13) return `${digits.slice(0, 6)}-${digits.slice(6)}`;
  return text;
}
export function formatDocumentRegistrationNumberText(value) {
  const text = String(value ?? '');
  const digits = documentNumericDigits(text);
  if (digits.length === 10) return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
  return text;
}
export function formatDocumentNumericTextLayerValue(key, label, value) {
  const text = String(value ?? '');
  if (!documentNumericDigits(text)) return text;
  const target = `${key} ${label}`.toLowerCase();
  if (/(?:phone|tel|\uC804\uD654|\uC5F0\uB77D\uCC98)/u.test(target)) return formatDocumentPhoneNumberText(text);
  if (/(?:rrn|resident|birth|\uC0DD\uB144\uC6D4\uC77C|\uC8FC\uBBFC)/u.test(target)) {
    return formatDocumentBirthOrResidentNumberText(text);
  }
  if (/(?:registration|license|\uB4F1\uB85D\uBC88\uD638)/u.test(target)) return formatDocumentRegistrationNumberText(text);
  return text;
}
export function normalizeDocumentTextLayerCustomText(key, value, label = '') {
  return formatDocumentNumericTextLayerValue(key, label, value);
}
const EXPLANATION_CONTRACT_TYPE_BY_INTERNAL_CODE = {
  SALE: 'sale',
  SELL: 'sale',
  SELLER: 'sale',
  SALECONTRACT: 'sale',
  EXCHANGE: 'sale',
  JEONSE: 'lease',
  MONTHLYRENT: 'lease',
  COMMERCIALLEASE: 'lease',
  LEASE: 'lease',
  RENT: 'lease',
  RENTAL: 'lease',
  OTHER: 'other'
};
const EXPLANATION_CONTRACT_TYPE_BY_LEGAL_LABEL = {
  매매: 'sale',
  매도: 'sale',
  매수: 'sale',
  매도인: 'sale',
  매수인: 'sale',
  교환: 'sale',
  매매교환: 'sale',
  전세: 'lease',
  월세: 'lease',
  임대: 'lease',
  임대차: 'lease',
  임대인: 'lease',
  임차인: 'lease',
  기타: 'other',
  그밖의경우: 'other'
};
export function normalizeExplanationContractTypeOption(contractType) {
  const raw = String(contractType ?? '').trim();
  if (!raw) return '';
  const internalCode = raw.toUpperCase().replace(/[\s_-]+/gu, '');
  const byInternalCode = EXPLANATION_CONTRACT_TYPE_BY_INTERNAL_CODE[internalCode];
  if (byInternalCode) return byInternalCode;
  const legalLabel = raw.replace(/[ㆍ·\s_-]+/gu, '').trim();
  const byLegalLabel = EXPLANATION_CONTRACT_TYPE_BY_LEGAL_LABEL[legalLabel];
  if (byLegalLabel) return byLegalLabel;
  if (/매매|매도|매수|교환/u.test(raw)) return 'sale';
  if (/임대|임차|임대차|전세|월세|렌트/u.test(raw)) return 'lease';
  if (/기타|그\s*밖/u.test(raw)) return 'other';
  return '';
}
function collapseNumericUnitSpacing(value) {
  return value.replace(/((?:\d+\s+)+\d+)\s*(\uB3D9|\uCE35|\uD638)/gu, (match, numberText, unit, offset, source) => {
    if (unit === '\uD638' && /-\s*$/u.test(source.slice(0, offset))) return match;
    return `${numberText.replace(/\s+/gu, '')}${unit}`;
  });
}
function normalizeLegacyJeNumericUnitSpacing(value) {
  return value.replace(/(^|\s)\uC81C\s+1\s+(\d{3,4})\s*(\uD638)/gu, '$1$2$3').replace(/(^|\s)\uC81C\s+(\d)\s+(\d{2,3})\s*(\uB3D9|\uCE35)/gu, '$1$2$3$4');
}
function splitConcatenatedHyphenUnitDigits(value) {
  let digits = value;
  const half = digits.length / 2;
  if (Number.isInteger(half) && half >= 4 && digits.slice(0, half) === digits.slice(half)) {
    digits = digits.slice(0, half);
  }
  for (const unitLength of [3, 4]) {
    const lotLength = digits.length - unitLength;
    if (lotLength < 1 || lotLength > 4) continue;
    const lotPart = digits.slice(0, lotLength);
    const unitPart = digits.slice(lotLength);
    if (/^0+$/u.test(unitPart)) continue;
    return `${lotPart} ${unitPart}\uD638`;
  }
  return '';
}
function normalizeConcatenatedAddressUnitSpacing(value) {
  return value.replace(/(\d+)-(\d{4,16})\s+\2\uD638(?=$|\s|[,.)\]])/gu, (match, mainNumber, tailDigits) => {
    const split = splitConcatenatedHyphenUnitDigits(tailDigits);
    return split ? `${mainNumber}-${split}` : match;
  }).replace(/(\d+)-(\d{4,16})\uD638(?=$|\s|[,.)\]])/gu, (match, mainNumber, tailDigits) => {
    const split = splitConcatenatedHyphenUnitDigits(tailDigits);
    return split ? `${mainNumber}-${split}` : match;
  });
}
function normalizeAddressLineText(value) {
  const prepared = normalizeConcatenatedAddressUnitSpacing(normalizeLegacyJeNumericUnitSpacing(String(value ?? '').normalize('NFKC')));
  const cleaned = collapseNumericUnitSpacing(prepared).replace(/(^|\s)\uC81C\s*(?=\d+\s*(?:\uB3D9|\uCE35|\uD638))/gu, '$1').replace(/(\d+)\s*(\uB3D9|\uCE35|\uD638)/gu, '$1$2').replace(/(\d+\uB3D9)(\d+\uD638)/gu, '$1 $2').replace(/\s+/gu, ' ').trim();
  return normalizeConcatenatedAddressUnitSpacing(cleaned).replace(/\s+/gu, ' ').trim();
}
function compactAddressLineText(value) {
  return normalizeAddressLineText(value).replace(/[\s,.\-_/()[\]{}]/gu, '');
}
function explanationAddressBaseLine(value) {
  const text = normalizeAddressLineText(value);
  const roadWithGil = text.match(/^(.+?(?:\uB85C\s*\d+\uAE38|\uB85C\d+\uBC88\uAE38|\uB85C\d*\uAE38|\uAE38)\s*\d+(?:-\d+)?)/u)?.[1];
  if (roadWithGil) return roadWithGil.trim();
  const road = text.match(/^(.+?\uB85C\s*\d+(?:-\d+)?)/u)?.[1];
  if (road) return road.trim();
  const jibun = text.match(/^(.+?(?:\uB3D9|\uC74D|\uBA74|\uB9AC|\uAC00)\s*\d+(?:-\d+)?)/u)?.[1];
  return (jibun ?? '').trim();
}
function trimRepeatedAddressTail(value) {
  const text = removeRepeatedAddressTokens(normalizeAddressLineText(value));
  const regionMatch = text.match(KOREAN_SIDO_PATTERN);
  if (regionMatch?.index && regionMatch.index > 0) return text.slice(0, regionMatch.index).trim();
  return text;
}
function splitAddressDetailSegments(value) {
  return normalizeAddressLineText(value).split(/\s*\/\s*|\s{2,}|,\s*/gu).map(segment => normalizeAddressLineText(segment)).filter(Boolean);
}
function appendUniqueAddressSegment(segments, candidate) {
  const clean = removeRepeatedAddressTokens(normalizeAddressLineText(candidate));
  const compact = compactAddressLineText(clean);
  if (!clean || !compact) return;
  for (let index = 0; index < segments.length; index += 1) {
    const existingCompact = compactAddressLineText(segments[index]);
    if (!existingCompact) continue;
    if (existingCompact === compact || existingCompact.includes(compact)) return;
    if (compact.includes(existingCompact)) {
      segments[index] = clean;
      return;
    }
  }
  segments.push(clean);
}
function uniqueAddressDetailText(...values) {
  const segments = [];
  values.flatMap(splitAddressDetailSegments).forEach(segment => appendUniqueAddressSegment(segments, segment));
  return removeRepeatedAddressTokens(segments.join(' '));
}
function firstText(...values) {
  for (const value of values) {
    const text = normalizeAddressLineText(value);
    if (text) return text;
  }
  return '';
}
function extractAddressUnitSuffix(value) {
  const text = normalizeAddressLineText(value);
  const match = text.match(/((?:\d+\uB3D9\s*)?(?:\d+\uCE35\s*)?(?:\d+\uD638))$/u);
  return match?.[1]?.replace(/\s+/gu, ' ').trim() ?? '';
}
function removeAddressUnitSuffix(value, unitText) {
  const text = normalizeAddressLineText(value);
  const unit = normalizeAddressLineText(unitText);
  if (!text || !unit) return text;
  const compactText = compactAddressLineText(text);
  const compactUnit = compactAddressLineText(unit);
  if (!compactText.endsWith(compactUnit)) return text;
  return normalizeAddressLineText(text.slice(0, Math.max(0, text.length - unit.length)));
}
export function formatExplanationObjectAddressParts(address, buildingName, unitText) {
  const source = trimRepeatedAddressTail(address);
  const baseLine = explanationAddressBaseLine(source);
  const detailSource = baseLine && source.length > baseLine.length ? source.slice(baseLine.length) : '';
  const unit = firstText(unitText, extractAddressUnitSuffix(detailSource), extractAddressUnitSuffix(source));
  const buildingFromDetail = removeAddressUnitSuffix(detailSource, unit);
  const building = uniqueAddressDetailText(buildingName, buildingFromDetail);
  const firstLine = removeRepeatedAddressTokens(baseLine || removeAddressUnitSuffix(source, unit));
  const secondLine = uniqueAddressDetailText(building, unit);
  const singleLine = removeRepeatedAddressTokens(secondLine && compactAddressLineText(firstLine) !== compactAddressLineText(secondLine) ? `${firstLine} ${secondLine}` : firstLine || secondLine || source);
  return {
    singleLine,
    firstLine: removeRepeatedAddressTokens(firstLine || source),
    secondLine
  };
}
function removeRepeatedAddressTokens(value) {
  const text = normalizeAddressLineText(value);
  if (!text) return '';
  const tokens = text.split(' ').filter(Boolean);
  const seen = new Set();
  const output = [];
  tokens.forEach(token => {
    const compact = compactAddressLineText(token);
    if (!compact) return;
    if (seen.has(compact)) return;
    seen.add(compact);
    output.push(token);
  });
  return output.join(' ').replace(/\s+/gu, ' ').trim();
}
export function formatExplanationObjectAddressLines(address, buildingName, unitText) {
  return formatExplanationObjectAddressParts(address, buildingName, unitText).singleLine;
}
export function formatExplanationObjectAddressTwoLines(address, buildingName, unitText) {
  const parts = formatExplanationObjectAddressParts(address, buildingName, unitText);
  if (!parts.firstLine || !parts.secondLine) return parts.singleLine;
  return `${parts.firstLine}\n${parts.secondLine}`;
}
export function formatExplanationAddressFallbackTwoLines(address) {
  const semanticTwoLine = formatExplanationObjectAddressTwoLines(address);
  if (semanticTwoLine.includes('\n')) return semanticTwoLine;
  const singleLine = formatExplanationObjectAddressLines(address);
  const words = normalizeAddressLineText(singleLine).split(' ').filter(Boolean);
  if (words.length <= 1) return singleLine;
  const unitIndex = words.findIndex(word => /^\d+(?:\uB3D9|\uCE35|\uD638)$/u.test(word));
  if (unitIndex > 0) {
    return `${words.slice(0, unitIndex).join(' ')}\n${words.slice(unitIndex).join(' ')}`;
  }
  let bestIndex = 1;
  let bestScore = Number.POSITIVE_INFINITY;
  for (let index = 1; index < words.length; index += 1) {
    const left = words.slice(0, index).join(' ');
    const right = words.slice(index).join(' ');
    const score = Math.abs(left.length - right.length);
    if (score < bestScore) {
      bestScore = score;
      bestIndex = index;
    }
  }
  return `${words.slice(0, bestIndex).join(' ')}\n${words.slice(bestIndex).join(' ')}`;
}
export function explanationOverlayIsAddressField(field) {
  const label = String(field.label ?? '').trim();
  const key = String(field.key ?? '').trim().toLowerCase();
  return label.includes('\uC8FC\uC18C') || label.includes('\uC18C\uC7AC\uC9C0') || label.includes('???') || label.includes('?????') || key === 'ef_p1_location' || key.endsWith('_address');
}
export function explanationOverlayMinimumFontSizePt(field) {
  const fieldMin = typeof field.minFontSize === 'number' && Number.isFinite(field.minFontSize) ? field.minFontSize : EXPLANATION_FORM_GENERAL_MIN_FONT_SIZE_PT;
  if (explanationOverlayIsAddressField(field)) {
    return Math.max(EXPLANATION_FORM_ADDRESS_MIN_FONT_SIZE_PT, fieldMin);
  }
  return Math.max(EXPLANATION_FORM_GENERAL_MIN_FONT_SIZE_PT, fieldMin);
}
export function explanationOverlaySingleLineFitMinimumFontSizePt(field) {
  if (explanationOverlayIsAddressField(field)) {
    return Math.max(EXPLANATION_FORM_GENERAL_MIN_FONT_SIZE_PT, EXPLANATION_FORM_ADDRESS_SINGLE_LINE_MIN_FONT_SIZE_PT);
  }
  return explanationOverlayMinimumFontSizePt(field);
}
export function formatExplanationAddressOverlayValue(field, value) {
  const text = String(value ?? '');
  const numericFormatted = formatDocumentNumericTextLayerValue(field.key, field.label, text);
  const formatted = normalizeRealtorAutoAreaUnitLabel(numericFormatted, numericFormatted);
  if (!formatted.trim() || !explanationOverlayIsAddressField(field)) return formatted;
  return formatExplanationObjectAddressLines(formatted);
}
function parseExplanationBrokerageFeeWon(value) {
  if (typeof value === 'number') return Number.isFinite(value) ? Math.round(value) : null;
  const raw = String(value ?? '').normalize('NFKC').trim().replace(/,/g, '');
  if (!raw) return null;
  let total = 0;
  let matchedUnit = false;
  for (const match of raw.matchAll(/(\d+(?:\.\d+)?)\s*\uC5B5/gu)) {
    total += Number(match[1]) * 100_000_000;
    matchedUnit = true;
  }
  for (const match of raw.matchAll(/(\d+(?:\.\d+)?)\s*\uB9CC/gu)) {
    total += Number(match[1]) * 10_000;
    matchedUnit = true;
  }
  if (matchedUnit) return Math.round(total);
  const numeric = raw.replace(/[^\d.]/gu, '');
  if (!numeric) return null;
  const parsed = Number(numeric);
  return Number.isFinite(parsed) ? Math.round(parsed) : null;
}
function formatExplanationBrokerageFeeWon(value) {
  const won = Math.max(0, Math.round(value));
  if (won >= 10_000 && won % 10_000 === 0) return `${(won / 10_000).toLocaleString('ko-KR')}만원`;
  return `${won.toLocaleString('ko-KR')}원`;
}
export function normalizeExplanationBrokerageFeeText(value) {
  const text = String(value ?? '').trim();
  if (!text) return '';
  const parsed = parseExplanationBrokerageFeeWon(text);
  if (parsed === null) return text;
  const rounded = parsed === 0 ? 0 : Math.ceil((Math.max(0, parsed) - Number.EPSILON) / 100) * 100;
  return formatExplanationBrokerageFeeWon(rounded);
}
export function normalizeExplanationTextLayerCustomText(key, value) {
  const text = String(value ?? '');
  if (key === 'ef_p4_brokerage_fee_max') return normalizeExplanationBrokerageFeeText(text);
  const field = EXPLANATION_FORM_TEXT_OVERLAYS.find(overlay => overlay.key === key);
  return field ? formatExplanationAddressOverlayValue(field, text) : normalizeDocumentTextLayerCustomText(key, text);
}
export function explanationOverlayNeedsWideInset(field, value) {
  const text = String(value ?? '').trim();
  const addressField = explanationOverlayIsAddressField(field);
  return (field.align === 'left' || addressField) && (addressField || field.multiline || text.includes('\n') || text.length >= 18);
}
const EXPLANATION_FORM_PREVIEW_PX_PER_PT = EXPLANATION_FORM_PREVIEW_BASE_WIDTH_PX / EXPLANATION_FORM_PAGE_WIDTH_PT;
export function explanationOverlayTextIsMultiline(field, text) {
  const value = String(text ?? '');
  const addressField = explanationOverlayIsAddressField(field);
  return addressField && value.includes('\n') || !addressField && (field.multiline || field.height >= 2.6 || value.includes('\n'));
}
export function explanationOverlayTextMinimumFontSizePt(field, text, multiline = explanationOverlayTextIsMultiline(field, text)) {
  if (explanationOverlayIsAddressField(field) && String(text ?? '').includes('\n')) {
    return EXPLANATION_FORM_GENERAL_MIN_FONT_SIZE_PT;
  }
  return multiline ? explanationOverlayMinimumFontSizePt(field) : explanationOverlaySingleLineFitMinimumFontSizePt(field);
}
export function explanationOverlayTextLineHeightPt(field, text, fontSizePt, boxHeightPt = field.height / 100 * EXPLANATION_FORM_PAGE_HEIGHT_PT) {
  return explanationOverlayTextIsMultiline(field, text) ? Math.max(fontSizePt * 1.16, fontSizePt + 1 / EXPLANATION_FORM_PREVIEW_PX_PER_PT) : Math.max(fontSizePt * 1.12, boxHeightPt - 2 / EXPLANATION_FORM_PREVIEW_PX_PER_PT);
}
function clampExplanationNumber(value, min, max) {
  return Math.min(max, Math.max(min, value));
}
export function explanationEstimatedTextWidthPt(text, fontSizePt) {
  const hasWideGlyph = /[^\u0000-\u00ff]/u.test(text);
  return text.length * fontSizePt * (hasWideGlyph ? 0.9 : 0.58);
}
export function explanationOverlayHorizontalPaddingPt(field, text) {
  return (explanationOverlayNeedsWideInset(field, text) ? EXPLANATION_FORM_LEFT_TEXT_INSET_PX : 2) / EXPLANATION_FORM_PREVIEW_PX_PER_PT;
}
export function explanationOverlayTextFontSizePt(field, text) {
  const heightPt = field.height / 100 * EXPLANATION_FORM_PAGE_HEIGHT_PT;
  const clean = String(text ?? '').replace(/\s+/gu, ' ').trim();
  const horizontalPaddingPt = explanationOverlayHorizontalPaddingPt(field, clean);
  const widthPt = Math.max(1, field.width / 100 * EXPLANATION_FORM_PAGE_WIDTH_PT - horizontalPaddingPt * 2);
  const heightBoxPt = Math.max(1, field.height / 100 * EXPLANATION_FORM_PAGE_HEIGHT_PT - 3 / EXPLANATION_FORM_PREVIEW_PX_PER_PT);
  const defaultPointSize = field.multiline ? Math.min(7.9, Math.max(6.6, heightPt / 3.6)) : Math.min(8.8, Math.max(6.4, heightPt - 2.2));
  const addressField = explanationOverlayIsAddressField(field);
  const singleLineMinPointSize = addressField ? explanationOverlaySingleLineFitMinimumFontSizePt(field) : explanationOverlayMinimumFontSizePt(field);
  const minPointSize = explanationOverlayTextMinimumFontSizePt(field, text);
  const basePointSize = Math.max(field.fontSize ?? defaultPointSize, singleLineMinPointSize);
  const maxPointSize = Math.max(basePointSize, minPointSize, 13.4 / EXPLANATION_FORM_PREVIEW_PX_PER_PT);
  if (!clean) return clampExplanationNumber(basePointSize, minPointSize, maxPointSize);
  const lineTexts = String(text ?? '').split(/\r?\n/u).map(line => line.trim()).filter(Boolean);
  const widestLineWidth = Math.max(...(lineTexts.length ? lineTexts : [clean]).map(line => explanationEstimatedTextWidthPt(line, basePointSize)), 1);
  const fittedByWidth = widestLineWidth > widthPt ? basePointSize * (widthPt / widestLineWidth) : basePointSize;
  if (!field.multiline && !text.includes('\n')) return clampExplanationNumber(fittedByWidth, minPointSize, maxPointSize);
  const estimatedLines = Math.max(1, (lineTexts.length ? lineTexts : [clean]).reduce((sum, line) => {
    const estimatedWidth = Math.max(1, explanationEstimatedTextWidthPt(line, basePointSize));
    return sum + Math.max(1, Math.ceil(estimatedWidth / Math.max(1, widthPt)));
  }, 0));
  const requiredHeight = estimatedLines * basePointSize * 1.16;
  const fittedByHeight = requiredHeight > heightBoxPt ? basePointSize * (heightBoxPt / requiredHeight) : basePointSize;
  return clampExplanationNumber(Math.min(fittedByWidth, fittedByHeight), minPointSize, maxPointSize);
}
export function shouldSplitExplanationAddressOverlayText(field, text) {
  if (!explanationOverlayIsAddressField(field)) return false;
  const clean = String(text ?? '').replace(/\s+/gu, ' ').trim();
  if (!clean) return false;
  const horizontalPaddingPt = explanationOverlayHorizontalPaddingPt(field, clean);
  const widthPt = Math.max(1, field.width / 100 * EXPLANATION_FORM_PAGE_WIDTH_PT - horizontalPaddingPt * 2);
  return explanationEstimatedTextWidthPt(clean, explanationOverlaySingleLineFitMinimumFontSizePt(field)) > widthPt;
}

// Official locked coordinates. These PDF text-layer boxes must match
// config/realtorauto-explanation-form-text-overlay-lock.json exactly.
// They use the user-confirmed full border areas, not auto-detected inner boxes.
export const EXPLANATION_FORM_TEXT_OVERLAYS = [textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_document_request_note',
  label: '자료요구 사항',
  x: 207.97,
  topY: 181.36,
  widthPt: 330.65,
  heightPt: 33.37,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_location',
  label: '소재지',
  x: 242.15,
  topY: 336.83,
  widthPt: 295.27,
  heightPt: 17.98,
  multiline: true,
  align: 'left',
  fontSize: 10,
  minFontSize: 10
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_area',
  label: '토지 면적',
  x: 242.15,
  topY: 357.21,
  widthPt: 81.56,
  heightPt: 26.85
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_category',
  label: '공부상 지목',
  x: 442.92,
  topY: 357.21,
  widthPt: 94.5,
  heightPt: 12.22
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_status',
  label: '실제 이용 상태',
  x: 442.92,
  topY: 371.84,
  widthPt: 94.5,
  heightPt: 12.22
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_exclusive_area',
  label: '전용면적',
  x: 242.15,
  topY: 386.46,
  widthPt: 124.73,
  heightPt: 12.22
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_site_right_area',
  label: '대지지분',
  x: 442.92,
  topY: 386.46,
  widthPt: 94.5,
  heightPt: 12.22
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_approval_year',
  label: '준공년도',
  x: 242.15,
  topY: 401.08,
  widthPt: 81.56,
  heightPt: 29.25
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_main_use_building',
  label: '건축물대장상 용도',
  x: 442.92,
  topY: 401.08,
  widthPt: 94.5,
  heightPt: 13.42
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_main_use_actual',
  label: '실제 용도',
  x: 442.92,
  topY: 416.9,
  widthPt: 94.5,
  heightPt: 13.42
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_structure',
  label: '구조',
  x: 242.15,
  topY: 432.73,
  widthPt: 81.56,
  heightPt: 14.62
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_direction_basis_left_value',
  label: '방향 기준',
  x: 444.8,
  topY: 432.73,
  widthPt: 40,
  heightPt: 14.62
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_seismic_design',
  label: '내진설계',
  x: 242.15,
  topY: 449.75,
  widthPt: 81.56,
  heightPt: 14.74
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_seismic_capacity',
  label: '내진능력',
  x: 441.72,
  topY: 448.55,
  widthPt: 96.9,
  heightPt: 17.14
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_violation_content',
  label: '위반내용',
  x: 369.28,
  topY: 466.89,
  widthPt: 168.14,
  heightPt: 27.33,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_registry_owner',
  label: '토지 소유권에 관한 사항',
  x: 213.01,
  topY: 518.91,
  widthPt: 153.88,
  heightPt: 40.51,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_registry_other_rights',
  label: '토지 소유권 외의 권리사항',
  x: 408.74,
  topY: 518.91,
  widthPt: 128.68,
  heightPt: 40.51,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_registry_land_right',
  label: '건축물 소유권에 관한 사항',
  x: 213.01,
  topY: 561.83,
  widthPt: 153.88,
  heightPt: 40.51,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_registry_restriction',
  label: '건축물 소유권 외의 권리사항',
  x: 408.74,
  topY: 561.83,
  widthPt: 128.68,
  heightPt: 40.51,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_region',
  label: '용도지역',
  x: 237.35,
  topY: 609.53,
  widthPt: 178.7,
  heightPt: 27.33
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_district',
  label: '용도지구',
  x: 237.35,
  topY: 639.26,
  widthPt: 178.7,
  heightPt: 27.33
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_building_coverage_limit',
  label: '건폐율 상한',
  x: 418.46,
  topY: 639.26,
  widthPt: 58.54,
  heightPt: 57.06
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_floor_area_ratio_limit',
  label: '용적률 상한',
  x: 478,
  topY: 639.26,
  widthPt: 59.42,
  heightPt: 57.06
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_zone',
  label: '용도구역',
  x: 237.35,
  topY: 668.99,
  widthPt: 178.7,
  heightPt: 27.33
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_city_county_plan_facility',
  label: '도시군계획시설',
  x: 166.47,
  topY: 697.52,
  widthPt: 92.23,
  heightPt: 52.74,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_unit_plan_extra',
  label: '지구단위계획구역 및 그 밖의 계획',
  x: 236.15,
  topY: 750.26,
  widthPt: 87.88,
  heightPt: 33.2,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_extra_restriction',
  label: '허가/거래규제',
  x: 423.25,
  topY: 751.46,
  widthPt: 114.16,
  heightPt: 30.8,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_small_tenant_amount_limit',
  label: '소액임차인범위',
  x: 252,
  topY: 132.5,
  widthPt: 41,
  heightPt: 9.5
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_priority_repayment_amount',
  label: '최우선변제금액',
  x: 423.5,
  topY: 132.5,
  widthPt: 36,
  heightPt: 9.5
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_private_rental_obligation_period',
  label: '민간임대 임대의무기간',
  x: 240.95,
  topY: 169.26,
  widthPt: 71.48,
  heightPt: 17.38
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_private_rental_start_date',
  label: '민간임대 임대개시일',
  x: 362.8,
  topY: 169.26,
  widthPt: 66.93,
  heightPt: 17.38
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_road_width_a',
  label: '도로 폭 1',
  x: 183.28,
  topY: 365.67,
  widthPt: 15.94,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_road_width_b',
  label: '도로 폭 2',
  x: 219.28,
  topY: 365.67,
  widthPt: 11.38,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_bus_stop_name',
  label: '버스 정류장',
  x: 236.5,
  topY: 398.43,
  widthPt: 58.3,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_bus_minutes',
  label: '버스 소요시간',
  x: 501,
  topY: 397.5,
  widthPt: 24.5,
  heightPt: 12
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_subway_station_name',
  label: '지하철역',
  x: 236.5,
  topY: 428.19,
  widthPt: 58.54,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_subway_minutes',
  label: '지하철 소요시간',
  x: 501,
  topY: 427.3,
  widthPt: 24.5,
  heightPt: 12
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_parking_other_detail',
  label: '그 밖의 주차시설',
  x: 282.22,
  topY: 466.11,
  widthPt: 105.58,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_elementary_school_name',
  label: '초등학교',
  x: 232.9,
  topY: 490.47,
  widthPt: 56.5,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_elementary_minutes',
  label: '초등학교 소요시간',
  x: 498.5,
  topY: 489.6,
  widthPt: 27,
  heightPt: 12
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_middle_school_name',
  label: '중학교',
  x: 232.9,
  topY: 514.59,
  widthPt: 56.5,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_middle_minutes',
  label: '중학교 소요시간',
  x: 498.5,
  topY: 513.7,
  widthPt: 27,
  heightPt: 12
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_high_school_name',
  label: '고등학교',
  x: 232.9,
  topY: 538.71,
  widthPt: 56.5,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_high_minutes',
  label: '고등학교 소요시간',
  x: 498.5,
  topY: 537.8,
  widthPt: 27,
  heightPt: 12
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_lease_confirm_lessor_role',
  label: '확인 임대인',
  x: 414.5,
  topY: 229,
  widthPt: 51.5,
  heightPt: 17
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_lease_confirm_lessee_role',
  label: '확인 임차인',
  x: 414.5,
  topY: 246,
  widthPt: 51.5,
  heightPt: 17.5
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_lease_confirm_realtor_role_1',
  label: '확인 개업공인중개사 1',
  x: 414.5,
  topY: 264,
  widthPt: 51.5,
  heightPt: 17.5
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_lease_confirm_realtor_role_2',
  label: '확인 개업공인중개사 2',
  x: 414.5,
  topY: 281.5,
  widthPt: 51.5,
  heightPt: 17.5
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_management_fee_amount',
  label: '관리비 금액',
  x: 289,
  topY: 588,
  widthPt: 26,
  heightPt: 13
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_management_fee_other_item_detail',
  label: '관리비 그 밖의 비목',
  x: 380.26,
  topY: 616.11,
  widthPt: 97.66,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_management_charge_other_detail',
  label: '그 밖의 부과방식',
  x: 342.82,
  topY: 643.71,
  widthPt: 172.06,
  heightPt: 11,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_disliked_facility_detail',
  label: '비선호시설 종류 및 위치',
  x: 361.54,
  topY: 670.71,
  widthPt: 114.1,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_transaction_amount',
  label: '거래예정금액',
  x: 237.35,
  topY: 700.88,
  widthPt: 301.4,
  heightPt: 21.56
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_public_land_price',
  label: '개별공시지가',
  x: 237.35,
  topY: 725.63,
  widthPt: 152,
  heightPt: 30.32
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_building_price',
  label: '건물 공시가격',
  x: 431,
  topY: 725.63,
  widthPt: 107.76,
  heightPt: 30.32
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_acquisition_tax_rate',
  label: '취득세율',
  x: 225.58,
  topY: 763.5,
  widthPt: 36.5,
  heightPt: 19
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_rural_special_tax_rate',
  label: '농어촌특별세율',
  x: 359.14,
  topY: 763.5,
  widthPt: 36.5,
  heightPt: 19
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 2,
  key: 'ef_p2_local_education_tax_rate',
  label: '지방교육세율',
  x: 496.3,
  topY: 763.5,
  widthPt: 36.5,
  heightPt: 19
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_actual_rights_unregistered_or_undisclosed',
  label: '실제 권리관계 또는 공시되지 않은 권리사항',
  x: 59.5,
  topY: 130,
  widthPt: 478.4,
  heightPt: 99.5,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_water_damage_location',
  label: '수도 파손 위치',
  x: 368.62,
  topY: 230.68,
  widthPt: 125.98,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_water_capacity_location',
  label: '용수량 부족 위치',
  x: 376.54,
  topY: 255.41,
  widthPt: 118.06,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_electric_repair_part',
  label: '전기 교체 부분',
  x: 416.62,
  topY: 280.13,
  widthPt: 77.98,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_gas_other_method',
  label: '가스 그 밖의 방식',
  x: 380.62,
  topY: 305.69,
  widthPt: 113.98,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_fire_detector_quantity',
  label: '소방 감지기 수량',
  x: 287.62,
  topY: 349.73,
  widthPt: 12.22,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_heating_repair_detail',
  label: '난방 수선 필요 내용',
  x: 448.42,
  topY: 385.37,
  widthPt: 41.98,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_heating_service_life',
  label: '난방 사용연한',
  x: 453.1,
  topY: 395.81,
  widthPt: 19.78,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_fuel_other_detail',
  label: '연료 그 밖의 종류',
  x: 308.62,
  topY: 430.73,
  widthPt: 49.9,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_drain_repair_location',
  label: '배수 수선 필요 위치',
  x: 294.34,
  topY: 476.57,
  widthPt: 206.02,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_other_facility_detail',
  label: '그 밖의 시설물',
  x: 171.75,
  topY: 493.38,
  widthPt: 367.38,
  heightPt: 28.65,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_wall_crack_location',
  label: '벽면 균열 위치',
  x: 344.86,
  topY: 534.53,
  widthPt: 178.06,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_wall_leak_location',
  label: '벽면 누수 위치',
  x: 344.86,
  topY: 559.49,
  widthPt: 178.06,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_floor_repair_location',
  label: '바닥 수리 필요 위치',
  x: 398.38,
  topY: 584.81,
  widthPt: 133.9,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 3,
  key: 'ef_p3_light_insufficient_reason',
  label: '일조량 불충분 이유',
  x: 386.38,
  topY: 640.97,
  widthPt: 117.94,
  heightPt: 11
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_brokerage_fee_max',
  label: '중개보수',
  x: 182.54,
  topY: 95.06,
  widthPt: 163.59,
  heightPt: 28.65,
  multiline: true,
  align: 'center'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_expense_fee',
  label: '실비',
  x: 182.54,
  topY: 126.1,
  widthPt: 163.59,
  heightPt: 28.65,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_total_fee',
  label: '계',
  x: 182.54,
  topY: 157.15,
  widthPt: 163.59,
  heightPt: 28.65,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_brokerage_formula',
  label: '중개보수 산출내역',
  x: 390,
  topY: 99.5,
  widthPt: 146.5,
  heightPt: 32.5,
  fontSize: 6.4,
  minFontSize: 6,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_expense_formula',
  label: '실비 산출내역',
  x: 390,
  topY: 128.5,
  widthPt: 146.5,
  heightPt: 20.5,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_payment_timing',
  label: '지급시기',
  x: 182.54,
  topY: 188.19,
  widthPt: 163.59,
  heightPt: 28.65
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_date_year',
  label: '작성 연도',
  x: 414,
  topY: 283,
  widthPt: 28.5,
  heightPt: 13
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_date_month',
  label: '작성 월',
  x: 463,
  topY: 283,
  widthPt: 15.5,
  heightPt: 13
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_date_day',
  label: '작성 일',
  x: 499,
  topY: 283,
  widthPt: 15.5,
  heightPt: 13
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_lessor_address',
  label: '매도인 주소',
  x: 182.54,
  topY: 303.75,
  widthPt: 157.95,
  heightPt: 35.6,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_lessor_name',
  label: '매도인 성명',
  x: 420.7,
  topY: 302.5,
  widthPt: 116.7,
  heightPt: 38.1
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_lessor_rrn',
  label: '매도인 생년월일',
  x: 182.54,
  topY: 341.75,
  widthPt: 157.95,
  heightPt: 35.6
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_lessor_phone',
  label: '매도인 전화번호',
  x: 421.93,
  topY: 341.75,
  widthPt: 114.26,
  heightPt: 35.6
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_lessee_address',
  label: '매수인 주소',
  x: 182.54,
  topY: 379.75,
  widthPt: 157.95,
  heightPt: 35.6,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_lessee_name',
  label: '매수인 성명',
  x: 420.7,
  topY: 378.5,
  widthPt: 116.7,
  heightPt: 38.1
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_lessee_rrn',
  label: '매수인 생년월일',
  x: 182.54,
  topY: 417.74,
  widthPt: 157.95,
  heightPt: 35.48
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_lessee_phone',
  label: '매수인 전화번호',
  x: 421.93,
  topY: 417.74,
  widthPt: 114.26,
  heightPt: 35.48
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_realtor_registration_no',
  label: '중개사 등록번호',
  x: 182.54,
  topY: 455.62,
  widthPt: 157.95,
  heightPt: 36.2
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_realtor_representative',
  label: '대표자 성명',
  x: 420.7,
  topY: 454.4,
  widthPt: 116.7,
  heightPt: 38.6
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_realtor_office_name',
  label: '사무소 명칭',
  x: 182.54,
  topY: 494.22,
  widthPt: 157.95,
  heightPt: 36.08
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_realtor_affiliated_broker',
  label: '소속공인중개사',
  x: 420.7,
  topY: 493,
  widthPt: 116.7,
  heightPt: 38.5
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_realtor_office_address',
  label: '사무소 소재지',
  x: 182.54,
  topY: 532.7,
  widthPt: 157.95,
  heightPt: 36.2,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_realtor_phone',
  label: '중개사 전화번호',
  x: 421.93,
  topY: 532.7,
  widthPt: 114.26,
  heightPt: 36.2
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_co_realtor_registration_no',
  label: '공동중개 등록번호',
  x: 182.54,
  topY: 570.7,
  widthPt: 157.95,
  heightPt: 36.2
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_co_realtor_representative',
  label: '공동중개 대표자 성명',
  x: 420.7,
  topY: 569.5,
  widthPt: 116.7,
  heightPt: 38.6
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_co_realtor_office_name',
  label: '공동중개 사무소 명칭',
  x: 182.54,
  topY: 609.3,
  widthPt: 157.95,
  heightPt: 36.08
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_co_realtor_affiliated_broker',
  label: '공동중개 소속공인중개사',
  x: 420.7,
  topY: 608.1,
  widthPt: 116.7,
  heightPt: 38.5
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_co_realtor_office_address',
  label: '공동중개 사무소 소재지',
  x: 182.54,
  topY: 647.78,
  widthPt: 157.95,
  heightPt: 36.2,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: RESIDENTIAL,
  page: 4,
  key: 'ef_p4_co_realtor_phone',
  label: '공동중개 전화번호',
  x: 421.93,
  topY: 647.78,
  widthPt: 114.26,
  heightPt: 36.2
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_document_request_note',
  label: '자료요구 사항',
  x: 181.46,
  topY: 140.85,
  widthPt: 344.16,
  heightPt: 48.18,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_location',
  label: '소재지',
  x: 215.65,
  topY: 300.75,
  widthPt: 308.77,
  heightPt: 18.82,
  multiline: true,
  align: 'left',
  fontSize: 10,
  minFontSize: 10
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_area',
  label: '토지 면적',
  x: 215.65,
  topY: 321.97,
  widthPt: 83.59,
  heightPt: 40.03
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_category',
  label: '공부상 지목',
  x: 417.74,
  topY: 321.97,
  widthPt: 106.68,
  heightPt: 18.82
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_status',
  label: '실제 이용 상태',
  x: 417.74,
  topY: 343.19,
  widthPt: 106.68,
  heightPt: 18.81
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_exclusive_area',
  label: '전용면적',
  x: 215.65,
  topY: 364.4,
  widthPt: 124.37,
  heightPt: 18.82
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_site_right_area',
  label: '대지지분',
  x: 417.74,
  topY: 364.4,
  widthPt: 106.68,
  heightPt: 18.82
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_approval_year',
  label: '준공년도',
  x: 215.65,
  topY: 385.62,
  widthPt: 83.59,
  heightPt: 40.15
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_main_use_building',
  label: '건축물대장상 용도',
  x: 417.74,
  topY: 385.62,
  widthPt: 106.68,
  heightPt: 18.94
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_main_use_actual',
  label: '실제 용도',
  x: 417.74,
  topY: 406.96,
  widthPt: 106.68,
  heightPt: 18.81
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_structure',
  label: '구조',
  x: 215.65,
  topY: 428.17,
  widthPt: 83.59,
  heightPt: 18.82
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_seismic_design',
  label: '내진설계',
  x: 215.65,
  topY: 449.39,
  widthPt: 83.59,
  heightPt: 18.82
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_seismic_capacity',
  label: '내진능력',
  x: 416.54,
  topY: 448.19,
  widthPt: 109.08,
  heightPt: 21.22
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_violation_content',
  label: '위반내용',
  x: 342.42,
  topY: 470.61,
  widthPt: 182,
  heightPt: 18.81,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_registry_owner',
  label: '토지 소유권에 관한 사항',
  x: 217.46,
  topY: 519.75,
  widthPt: 126.75,
  heightPt: 21.69,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_registry_other_rights',
  label: '토지 소유권 외의 권리사항',
  x: 403.1,
  topY: 519.75,
  widthPt: 121.31,
  heightPt: 21.69,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_registry_land_right',
  label: '건축물 소유권에 관한 사항',
  x: 217.46,
  topY: 543.85,
  widthPt: 126.75,
  heightPt: 21.69,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_registry_restriction',
  label: '건축물 소유권 외의 권리사항',
  x: 403.1,
  topY: 543.85,
  widthPt: 121.31,
  heightPt: 21.69,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_private_rental_type_detail',
  label: '민간임대 그 밖의 유형',
  x: 401.9,
  topY: 566.74,
  widthPt: 123.72,
  heightPt: 23.49,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_private_rental_obligation_period',
  label: '민간임대 임대의무기간',
  x: 216.26,
  topY: 590.23,
  widthPt: 129.15,
  heightPt: 11.75
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_private_rental_start_date',
  label: '민간임대 임대개시일',
  x: 401.9,
  topY: 590.23,
  widthPt: 123.72,
  heightPt: 11.75
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_renewal_request_status',
  label: '계약갱신 요구권 행사여부',
  x: 345.41,
  topY: 601.98,
  widthPt: 180.21,
  heightPt: 22.78,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_region',
  label: '용도지역',
  x: 215.65,
  topY: 662.64,
  widthPt: 182.06,
  heightPt: 15.94
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_district',
  label: '용도지구',
  x: 215.65,
  topY: 680.98,
  widthPt: 182.06,
  heightPt: 16.06
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_building_coverage_limit',
  label: '건폐율 상한',
  x: 400.1,
  topY: 680.98,
  widthPt: 61.9,
  heightPt: 34.52
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_floor_area_ratio_limit',
  label: '용적률 상한',
  x: 464,
  topY: 680.98,
  widthPt: 60.42,
  heightPt: 34.52
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_zone',
  label: '용도구역',
  x: 215.65,
  topY: 699.44,
  widthPt: 182.06,
  heightPt: 16.06
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_city_county_plan_facility',
  label: '도시군계획시설',
  x: 140.56,
  topY: 716.7,
  widthPt: 91.4,
  heightPt: 39.19,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_unit_plan_extra',
  label: '지구단위계획구역 및 그 밖의 계획',
  x: 192.14,
  topY: 755.89,
  widthPt: 122.47,
  heightPt: 32.73,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 1,
  key: 'ef_p1_land_use_extra_restriction',
  label: '허가/거래규제',
  x: 400.1,
  topY: 757.09,
  widthPt: 124.31,
  heightPt: 30.32,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_road_width_a',
  label: '도로 폭 1',
  x: 149.92,
  topY: 61.35,
  widthPt: 13.06,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_road_width_b',
  label: '도로 폭 2',
  x: 178.24,
  topY: 61.35,
  widthPt: 9.58,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_bus_stop_name',
  label: '버스 정류장',
  x: 227.5,
  topY: 86.17,
  widthPt: 49.06,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_bus_minutes',
  label: '버스 소요시간',
  x: 459,
  topY: 86,
  widthPt: 21,
  heightPt: 12
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_subway_station_name',
  label: '지하철역',
  x: 227.5,
  topY: 110.29,
  widthPt: 49.06,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_subway_minutes',
  label: '지하철 소요시간',
  x: 459,
  topY: 110,
  widthPt: 21,
  heightPt: 12
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_parking_other_detail',
  label: '그 밖의 주차시설',
  x: 479.38,
  topY: 134.31,
  widthPt: 38.26,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_transaction_amount',
  label: '거래예정금액',
  x: 215.65,
  topY: 196.74,
  widthPt: 308.77,
  heightPt: 14.1
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_public_land_price',
  label: '개별공시지가',
  x: 218.76,
  topY: 211.09,
  widthPt: 108.42,
  heightPt: 24.09
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_building_price',
  label: '건물 공시가격',
  x: 413.66,
  topY: 211.09,
  widthPt: 111.42,
  heightPt: 24.09
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_acquisition_tax_rate',
  label: '취득세율',
  x: 177,
  topY: 244,
  widthPt: 30,
  heightPt: 16.5
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_rural_special_tax_rate',
  label: '농어촌특별세율',
  x: 290,
  topY: 244,
  widthPt: 30,
  heightPt: 16.5
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p2_local_education_tax_rate',
  label: '지방교육세율',
  x: 488.5,
  topY: 244,
  widthPt: 30,
  heightPt: 16.5
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_actual_rights_unregistered_or_undisclosed',
  label: '실제 권리관계 또는 공시되지 않은 권리사항',
  x: 43,
  topY: 361.5,
  widthPt: 480.5,
  heightPt: 84,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_water_damage_location',
  label: '누수 위치',
  x: 343.66,
  topY: 448.24,
  widthPt: 117.94,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_water_capacity_location',
  label: '용수량 부족 위치',
  x: 351.34,
  topY: 472.36,
  widthPt: 110.26,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_electric_repair_part',
  label: '전기 교체 부분',
  x: 390.22,
  topY: 496.48,
  widthPt: 75.34,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_gas_other_method',
  label: '가스 그 밖의 방식',
  x: 355.3,
  topY: 520.48,
  widthPt: 136.66,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_fire_detector_quantity',
  label: '소방 위치',
  x: 343.66,
  topY: 544.6,
  widthPt: 117.94,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_heating_repair_detail',
  label: '냉난방 수선 필요 내용',
  x: 459.28,
  topY: 588.88,
  widthPt: 24.52,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_heating_service_life',
  label: '개별공급 사용연한',
  x: 459.64,
  topY: 600.68,
  widthPt: 17.8,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_fuel_other_detail',
  label: '연료 그 밖의 종류',
  x: 488.74,
  topY: 616.84,
  widthPt: 29.5,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_drain_repair_location',
  label: '배수 수선 필요 위치',
  x: 274.9,
  topY: 665.08,
  widthPt: 187.9,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_other_facility_detail',
  label: '그 밖의 시설물',
  x: 157.48,
  topY: 681.81,
  widthPt: 367.6,
  heightPt: 24.1,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_wall_crack_location',
  label: '벽면 균열 위치',
  x: 301.54,
  topY: 712.36,
  widthPt: 176.26,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_wall_leak_location',
  label: '벽면 누수 위치',
  x: 301.54,
  topY: 727,
  widthPt: 176.26,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 2,
  key: 'ef_p3_floor_repair_location',
  label: '바닥 수리 필요 위치',
  x: 347.86,
  topY: 748.21,
  widthPt: 121.9,
  heightPt: 11
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_brokerage_fee_max',
  label: '중개보수',
  x: 167.91,
  topY: 103.57,
  widthPt: 161.79,
  heightPt: 26.73,
  multiline: true,
  align: 'center'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_expense_fee',
  label: '실비',
  x: 167.91,
  topY: 132.7,
  widthPt: 161.79,
  heightPt: 26.61,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_total_fee',
  label: '계',
  x: 167.91,
  topY: 161.7,
  widthPt: 161.79,
  heightPt: 26.73,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_brokerage_formula',
  label: '중개보수 산출내역',
  x: 375,
  topY: 120.5,
  widthPt: 146,
  heightPt: 35.5,
  fontSize: 6.4,
  minFontSize: 6,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_expense_formula',
  label: '실비 산출내역',
  x: 375,
  topY: 154,
  widthPt: 146,
  heightPt: 20,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_payment_timing',
  label: '지급시기',
  x: 167.91,
  topY: 190.83,
  widthPt: 161.79,
  heightPt: 36.08
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_date_year',
  label: '작성 연도',
  x: 359,
  topY: 319,
  widthPt: 26.5,
  heightPt: 13
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_date_month',
  label: '작성 월',
  x: 406,
  topY: 319,
  widthPt: 15.5,
  heightPt: 13
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_date_day',
  label: '작성 일',
  x: 442,
  topY: 319,
  widthPt: 15.5,
  heightPt: 13
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_lessor_address',
  label: '매도인 주소',
  x: 153.76,
  topY: 343.78,
  widthPt: 158.43,
  heightPt: 42.91,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_lessor_name',
  label: '매도인 성명',
  x: 365.3,
  topY: 342.6,
  widthPt: 157.6,
  heightPt: 45.3
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_lessor_rrn',
  label: '매도인 생년월일',
  x: 153.76,
  topY: 389.1,
  widthPt: 158.43,
  heightPt: 42.79
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_lessor_phone',
  label: '매도인 전화번호',
  x: 365.32,
  topY: 389.1,
  widthPt: 156.36,
  heightPt: 42.79
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_lessee_address',
  label: '매수인 주소',
  x: 153.76,
  topY: 434.29,
  widthPt: 158.43,
  heightPt: 42.91,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_lessee_name',
  label: '매수인 성명',
  x: 365.3,
  topY: 433.1,
  widthPt: 157.6,
  heightPt: 45.3
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_lessee_rrn',
  label: '매수인 생년월일',
  x: 153.76,
  topY: 479.6,
  widthPt: 158.43,
  heightPt: 42.91
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_lessee_phone',
  label: '매수인 전화번호',
  x: 365.32,
  topY: 479.6,
  widthPt: 156.36,
  heightPt: 42.91
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_realtor_registration_no',
  label: '중개사 등록번호',
  x: 153.76,
  topY: 524.91,
  widthPt: 158.43,
  heightPt: 39.55
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_realtor_representative',
  label: '대표자 성명',
  x: 365.3,
  topY: 523.7,
  widthPt: 157.6,
  heightPt: 42
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_realtor_office_name',
  label: '사무소 명칭',
  x: 153.76,
  topY: 566.86,
  widthPt: 158.43,
  heightPt: 39.67
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_realtor_affiliated_broker',
  label: '소속공인중개사',
  x: 365.3,
  topY: 565.7,
  widthPt: 157.6,
  heightPt: 42.1
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_realtor_office_address',
  label: '사무소 소재지',
  x: 153.76,
  topY: 608.93,
  widthPt: 158.43,
  heightPt: 46.15,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_realtor_phone',
  label: '중개사 전화번호',
  x: 365.32,
  topY: 608.93,
  widthPt: 156.36,
  heightPt: 46.15
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_co_realtor_registration_no',
  label: '공동중개 등록번호',
  x: 153.76,
  topY: 655.45,
  widthPt: 158.43,
  heightPt: 39.55
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_co_realtor_representative',
  label: '공동중개 대표자 성명',
  x: 365.3,
  topY: 654.24,
  widthPt: 157.6,
  heightPt: 42
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_co_realtor_office_name',
  label: '공동중개 사무소 명칭',
  x: 153.76,
  topY: 697.4,
  widthPt: 158.43,
  heightPt: 39.67
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_co_realtor_affiliated_broker',
  label: '공동중개 소속공인중개사',
  x: 365.3,
  topY: 696.24,
  widthPt: 157.6,
  heightPt: 42.1
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_co_realtor_office_address',
  label: '공동중개 사무소 소재지',
  x: 153.76,
  topY: 739.47,
  widthPt: 158.43,
  heightPt: 46.15,
  multiline: true,
  align: 'left'
}), textOverlay({
  formKey: NONRESIDENTIAL,
  page: 3,
  key: 'ef_p4_co_realtor_phone',
  label: '공동중개 전화번호',
  x: 365.32,
  topY: 739.47,
  widthPt: 156.36,
  heightPt: 46.15
})];
